import React, { Component } from 'react';
import { loginActions } from '../../action/loginAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
class TermsCondition extends Component {
	constructor(props) {
		super(props);
	}
	componentDidMount() {
		//  window.setAccordian();
	}

	handleSMSClick = () => {
		const link = `${process.env.REACT_APP_DESKTOP_URL}?plyrid=${this.props.user.referralid}`;
		window.location.href = `sms:?body=Here is my referral link: ${link}`;
	};
	render() {
		const { t } = this.props;
		const { i18n } = this.props;

		return (
			<>
				{process.env.REACT_APP_MODE != "development" && <Helmet>
					<title>Gulf Ticket : Terms And Condition</title>
					<meta name="description" content="Gulf Ticket Terms And Condition" />
				</Helmet>
				}
				<div className='wrap1'>
					{/* <h2 className="headding3 float-none">Terms and Conditions</h2> */}
					{/* {i18n.language === 'en' && <h2 className="headding3 float-none">Terms and Conditions</h2>} */}
					{/* {i18n.language === 'ml' && <h2 className="headding3 float-none">ഉപാധികളും നിബന്ധനകളും</h2>} */}
					{/* {i18n.language === 'ar' && <h2 className="headding3 float-none">الأحكام والشروط</h2>} */}
					{/* {i18n.language === 'ur' && <h2 className="headding3 float-none">شرائط و ضوابط</h2>} */}
					{/* {i18n.language === 'en' ? */}
					<div class="staticCont">
						<h2 class="headding1 padding-top-20">Terms & Conditions</h2>

						<h3 class="padding-bottom-20">Introduction</h3>
						<p>Gulfticket.com is operated by Future I Tech System Limited, a company duly registered and licensed under the jurisdiction of the Gambling Control Authority (GCA), Samoa, with its principal registered office in accordance with the provisions of Samoan law ("Gulfticket", "we", "us", or "our").</p>
						<p>These Terms and Conditions ("Terms") govern your access to and use of our website (<a target='_blank' href='https://gulfticket.com'> www.gulfticket.com</a> and its related subdomains, mobile versions, and associated platforms) and our services (the "Services").</p>

						<span>Our Services include:</span>
						<div class="staticContLi">
							<ul>
								<li>Lottery Betting: Placing real-money stakes on the outcome of certified and official lottery-style draws using a random number generator (RNG).</li>
								<li>Instant RNG Games: Including but not limited to scratch cards, instant table games, casino-style RNG games, and spin-based games.</li>
								<li>Promotional Games and Loyalty Programs: Including Lucky Wheel, Cashback Offers, VIP Club, and Bonus Campaigns.</li>
							</ul>
						</div>
						<p>Please note: Gulfticket does not sell official lottery tickets. You are placing a bet with us on the outcome of lottery-style or RNG-based results.</p>
						<p>We are fully licensed by the Gambling Control Authority of Samoa, in accordance with the Interactive Gaming License granted to Future I Tech System Limited. For further information on our license and the regulator, visit <a href='https://www.gcasamoa.ws'>https://www.gcasamoa.ws</a> </p>

						<h3 class="padding-bottom-20">Acceptance of Terms</h3>
						<span>By accessing and using our Website and Services, you confirm that you:</span>
						<div class="staticContLi">
							<ul>
								<li>Are at least 18 years old;</li>
								<li>Are legally permitted to participate in online gaming in your jurisdiction;</li>
								<li>Have read, understood, and agreed to these Terms</li>
							</ul>
						</div>

						<span>These Terms include, by reference, our:</span>
						<div class="staticContLi">
							<ul>
								<li>Privacy Policy</li>
								<li>Cookie Policy</li>
								<li>Bonus and Promotion Rules</li>
								<li>Responsible Gaming Policy</li>
								<li>AML/KYC Policy</li>
							</ul>
						</div>
						<p>We reserve the right to amend these Terms from time to time. If we make material changes, you will be notified at your next login or via email. Continued use of our services constitutes acceptance of the revised Terms.</p>


						<h3 class="padding-bottom-20">Registration and User Account</h3>
						<p>To use our Services, you must register and create an account. You agree to provide accurate, current, and complete information and to update it regularly.</p>
						<p>You may only register one account. Duplicate accounts may be suspended or closed at our discretion.</p>
						<span>You must not:</span>
						<div class="staticContLi">
							<ul>
								<li>Provide false information;</li>
								<li>Use the Services on behalf of anyone else;</li>
								<li>Use the Services on behalf of anyone else;</li>
								<li>Deposit or play with funds derived from criminal activities.</li>
							</ul>
						</div>
						<p>We reserve the right to request verification documents at any time and to suspend or terminate accounts pending verification.</p>


						<h3 class="padding-bottom-20">Responsible Gaming & Player Protection</h3>
						<span>We are committed to promoting responsible gaming and preventing gambling harm. Features available include:</span>
						<div class="staticContLi"> <ul>
							<li>Deposit Limits</li>
							<li>Time-outs</li>
							<li>Self-Exclusion</li>
							<li>Access to third-party support tools</li>
						</ul>
						</div>
						<p>Players under 18 are strictly prohibited. Any account found to be operated by an underage user will be closed and funds forfeited.</p>

						<h3 class="padding-bottom-20">Deposits and Withdrawals</h3>
						<p>You must deposit funds into your account to place bets. All deposits must come from a payment method in your name.</p>
						<p>Withdrawals will only be processed after successful KYC and subject to anti-money laundering screening.</p>
						<p>We may apply withdrawal limits, minimum thresholds, and processing fees in line with our payment policy.</p>
						<p>Funds held in your account do not earn interest and are not held in escrow.</p>

						<h3 class="padding-bottom-20">Use of Services</h3>
						<span>By placing a bet, you:</span>
						<div class="staticContLi"> <ul>
							<li>Confirm you understand the rules of the game;</li>
							<li>Accept that all outcomes are determined by certified RNG or lottery results;</li>
							<li>Acknowledge that you may lose funds and accept that risk.</li>
						</ul>
						</div>

						<span>We reserve the right to:</span>
						<div class="staticContLi"> <ul>
							<li>Cancel bets placed due to technical errors or fraud;</li>
							<li>Suspend accounts under investigation;</li>
							<li>Refuse service to anyone violating these Terms.</li>
						</ul>
						</div>

						<h3 class="padding-bottom-20">Winnings and Payouts</h3>
						<span>All winnings are subject to verification. We reserve the right to withhold or void winnings in cases of:</span>
						<div class="staticContLi"> <ul>
							<li>Technical errors;</li>
							<li>Suspected collusion or fraud;</li>
							<li>Violation of gameplay rules or Terms.</li>
						</ul>
						</div>
						<p>Winnings may be subject to local tax laws. You are responsible for declaring such income.</p>

						<h3 class="padding-bottom-20">Prohibited Jurisdictions</h3>
						<p>Users from the following countries are not permitted to use our Services: United States, North Korea, Syria, Iran, Russia, Belarus, and any country on the FATF high-risk list.</p>
						<h3 class="padding-bottom-20">Dispute Resolution and Complaints</h3>
						<p>If you have a complaint, contact us at  helpdesk@gulfticket.com. If we cannot resolve your issue, you may escalate it to the Gambling Control Authority, Samoa.</p>

						<h3 class="padding-bottom-20">Governing Law</h3>
						<p>These Terms shall be governed by and construed in accordance with the laws of Samoa. Any legal action or proceeding shall be brought in the competent courts of Samoa.</p>
						<h3 class="padding-bottom-20">Bonus Terms and Conditions</h3>
						<p>All bonus offers are subject to specific wagering requirements and eligibility criteria.</p>
						<p>Bonus funds are non-withdrawable until all wagering requirements have been met.</p>
						<p>Users may only have one active bonus at a time, unless otherwise stated.</p>
						<p>Abuse of bonuses may result in forfeiture of the bonus and related winnings.</p>
						<p>Bonus terms may vary by promotion and will be published on the relevant campaign page.</p>



						<h3 class="padding-bottom-20">Game Fairness and RNG Integrity</h3>
						<p>All instant games and scratch cards on Gulfticket.com operate using a certified and independently audited Random Number Generator (RNG) to ensure fairness.</p>
						<p>We undergo periodic testing and certification as mandated by the Gambling Control Authority, Samoa.</p>
						<p>We reserve the right to void games affected by technical malfunction or exploitation.</p>

						<h3 class="padding-bottom-20">Fraud and Anti-Money Laundering (AML)</h3>
						<p>We are committed to preventing money laundering and fraud. All user activities are monitored to identify suspicious behavior.</p>
						<p>We may suspend or terminate any account that fails AML checks or where we reasonably suspect unlawful activity.</p>
						<p>You agree to cooperate fully in any verification or compliance check initiated by Gulfticket or the GCA.</p>

						<h3 class="padding-bottom-20">Account Closure and Inactivity</h3>
						<p>You may close your account at any time by contacting our support team.</p>
						<span>We reserve the right to close or suspend accounts that:</span>
						<div class="staticContLi">
							<ul>
								<li>Are inactive for 12 consecutive months;</li>
								<li>Appear to be used fraudulently or in breach of these Terms;</li>
								<li>Are linked to self-exclusion requests.</li>
							</ul>
						</div>
						<p>Inactive account balances may be subject to administrative fees after a grace period, as outlined in our payment policy.</p>
						<h3 class="padding-bottom-20">Intellectual Property</h3>
						<p>All website content, including games, text, logos, software, graphics, and media, is owned or licensed by Gulfticket and protected by copyright and trademark laws.</p>
						<p>You may not copy, distribute, modify, or reverse-engineer any part of our platform without prior written consent.</p>
						<h3 class="padding-bottom-20">Third-Party Content and Links</h3>
						<p>We may provide links to third-party websites or services. These are provided for your convenience, and we do not accept responsibility for their content or conduct.</p>
						<p>Accessing any third-party site is at your own risk and subject to their own terms and policies.</p>

						<h3 class="padding-bottom-20">Data Protection and Privacy</h3>
						<p>Your privacy is important to us. We collect, store, and process your data in accordance with our Privacy Policy.</p>
						<p>We comply with applicable data protection laws, including GDPR and regional equivalents.</p>
						<h3 class="padding-bottom-20">Cookie Policy</h3>
						<p>We use cookies and similar technologies to enhance user experience and collect analytical data. Full details are available in our Cookie Policy.</p>
						<p>By using our website, you consent to the use of cookies unless you disable them in your browser settings.</p>
						<h3 class="padding-bottom-20">Promotions and Competitions</h3>
						<p>All promotional offers and competitions are subject to their own specific terms and may be withdrawn at any time.</p>
						<p>Misuse or manipulation of promotional campaigns is strictly prohibited.</p>
						<p>We reserve the right to withhold promotions or winnings if fraudulent or abusive behaviour is detected.</p>

						<h3 class="padding-bottom-20">Affiliates and Referral Programs</h3>
						<p>We may operate affiliate or referral programs from time to time. Participation is subject to our Affiliate Terms and Conditions.</p>
						<p>Gulfticket reserves the right to modify, suspend, or terminate affiliate programs at any time.</p>


						<h3 class="padding-bottom-20">Limitation of Liability</h3>
						<p>To the fullest extent permitted by law, Gulfticket shall not be liable for any direct, indirect, incidental, special, or consequential damages arising from your use of or inability to use our Services.</p>
						<p>We do not guarantee continuous, uninterrupted, or secure access to our platform. Services may be affected by factors beyond our control.</p>

						<h3 class="padding-bottom-20"> Force Majeure</h3>
						<p>We are not liable for any failure to perform our obligations due to events beyond our reasonable control, including but not limited to natural disasters, power failures, strikes, government actions, or network failures.</p>
						<h3 class="padding-bottom-20">Termination by Company</h3>
						<p>We reserve the right to suspend or terminate your account and access to Services at our sole discretion, without prior notice, in cases including but not limited to:</p>
						<div class="staticContLi">
							<ul>
								<li>Breach of these Terms;</li>
								<li>Fraudulent or criminal activity;</li>
								<li>Regulatory or legal requirements</li>
							</ul>
						</div>

						<h3 class="padding-bottom-20">Language and Interpretation</h3>
						<p>These Terms are published in English. In the event of conflict between translated versions, the English version shall prevail.</p>


						<h3 class="padding-bottom-20">Severability</h3>
						<p>If any provision of these Terms is held to be invalid or unenforceable, the remaining provisions shall remain in full force and effect.</p>

						<h3 class="padding-bottom-20">Assignment</h3>
						<p>You may not assign or transfer your rights or obligations under these Terms. We may assign these Terms without restriction.</p>

						<h3 class="padding-bottom-20">Entire Agreement</h3>
						<p>These Terms, together with the documents incorporated by reference, constitute the entire agreement between you and Gulfticket.</p>


						<h3 class="padding-bottom-20">Taxation and User Responsibility</h3>
						<p>You are solely responsible for declaring and paying any taxes applicable to your winnings or income derived from using our Services, according to your jurisdiction.</p>

						<h3 class="padding-bottom-20">Forgotten Credentials and Account Recovery</h3>
						<p>If you forget your login details, you may recover access using the “Forgot Password” function. Additional identity verification may be required.</p>



						<h3 class="padding-bottom-20">Contact</h3>
						<p>If you have any questions about these Terms or your account, please contact us at: legal@gulfticket.com or helpdesk@gulfticket.com.</p>


						<h2 class="headding1 padding-top-20">SCHEDULE 1: Rules on Lottery Betting</h2>
						<p>These Rules on Lottery Betting form part of the Terms and Conditions set out in the User Agreement.</p>
						<h3 class="padding-bottom-20">Part A: Lottery Betting</h3>
						<h3 class="padding-bottom-20">1. INTRODUCTION</h3>
						<p>Gulfticket offers betting on the results of official lotteries and/or lottery-style draws using certified random number generator technology and mechanical draw machines ("Lottery Betting"), as set out in the User Agreement. Please read the Terms and Conditions in full before participating in Lottery Betting.</p>
						<p>The terms “Underlying Lottery”, “Underlying Lottery Operator”, “Type A Prize Category”, “Type B Prize Category”, and “Type C Prize Category” have the meanings given in section 2.2 and section 3.3 of this Schedule.</p>
						<p>The term “Prize Category” refers to any of the Type A, B, or C Prize Categories, as applicable. The term “Prize” means any monetary reward awarded under a Prize Category.</p>
						<p>The term “RNG” refers to the certified Random Number Generator technology used by Gulfticket to determine lottery-style draw results. In addition, Gulfticket uses Smartplay-certified mechanical draw machines for live draws.</p>
						<p>Where applicable, certain draws conducted by Gulfticket may be carried out using physical draw machines provided by Smartplay International, USA. These draws are broadcasted live through our official YouTube channel and other authorized social media platforms.</p>

						<h3 class="padding-bottom-20">Winnings</h3>
						<p>Gulfticket calculates the winnings for each legitimate and winning Bet. The calculation is based on the applicable Underlying Lottery structure and Prize Category unless stated otherwise within these Rules or on the Website.</p>
						<span>Overview of Lottery Betting Prize Category Classifications:</span>
						<div class="staticContLi">
							<ul>
								<li>Type A Prize Category: Matches the highest prize tier (e.g., jackpot or equivalent). This is calculated based on the official draw results of the Underlying Lottery, Gulfticket-hosted RNG-based draws, or live physical draws conducted with Smartplay machines. If there are multiple valid winning Bets in a Type A Prize Category (Main Jackpot), the prize amount shall be divided equally among all such winning Bets.</li>
								<li>Type B Prize Category: Matches secondary prize tiers (e.g., second or third tier). These are also mapped to Underlying Lottery results or equivalent Gulfticket draw outcomes.</li>
								<li>Type C Prize Category: Includes lower-tier prizes such as matching fewer numbers or specific combinations, awarded based on the predefined payout tables.</li>
							</ul>
						</div>

						<h3 class="padding-bottom-20">Additional Notes on Lottery Betting</h3>
						<p>In the event a Bet matches multiple Prize Categories, only the highest eligible Prize Category will be paid out.</p>
						<p>For RNG-based draws, results are generated through certified software independently verified for randomness and fairness. For physical draws, Smartplay machines are used in accordance with internationally accepted standards.</p>
						<p>In cases of force majeure or technical failure that affects draw generation or live stream integrity, the Bet may be voided and the original stake refunded, at Gulfticket’s discretion.</p>
						<p>Gulfticket reserves the right to limit maximum payouts on specific draws as detailed in the Game Rules or promotional terms.</p>

						<h2 class="headding1 padding-top-20">PLAY LOTTO STRUCTURE</h2>
						<p class="padding-bottom-20"><b>Lottery Betting Event:</b> Play Lotto</p>
						<p><b>Ball Pool Range:</b> Numbers drawn are from a pool of 1 to 36</p>
						<p><b>Underlying Lottery:</b> Gulfticket-hosted draw using Smartplay RNG and mechanical draw systems</p>
						<p><b>Underlying Lottery Operator:</b> Future I Tech System Ltd (licensed by the Gambling Control Authority, Samoa)</p>

						<div class="table">
							<ul class="transTble transTble2">
								<li>
									<div class="w-40 text-left">Prize Category</div>
									<div class="w-15 text-left">Balls Matched</div>
									<div class="w-15 text-left">Odds</div>
									<div class="w-15 text-left">No of Combinations</div>
									<div class="w-15 text-left">Prize Value (USD)</div>
								</li>
								<li>
									<div class="w-40">Type A</div>
									<div class="w-15">5</div>
									<div class="w-15">1 in 376,992</div>
									<div class="w-15">1</div>
									<div class="w-15">$50,000*</div>
								</li>
								<li>
									<div class="w-40">Type B</div>
									<div class="w-15">4</div>
									<div class="w-15">1 in 2,432</div>
									<div class="w-15">155</div>
									<div class="w-15">$50</div>
								</li>
								<li>
									<div class="w-40">Type C</div>
									<div class="w-15">3</div>
									<div class="w-15">1 in 81</div>
									<div class="w-15">4,650</div>
									<div class="w-15">$5</div>
								</li>
								<li>
									<div class="w-40">Type C</div>
									<div class="w-15">2</div>
									<div class="w-15">1 in 8.39</div>
									<div class="w-15">44,950</div>
									<div class="w-15">$0.50</div>
								</li>
								<li>
									<div class="w-40">–</div>
									<div class="w-15">1</div>
									<div class="w-15">1 in 2.4</div>
									<div class="w-15">157,325</div>
									<div class="w-15">$0</div>
								</li>
							</ul>
						</div>


						<h2 class="headding1 padding-top-20">MINI LOTTO STRUCTURE</h2>
						<p class="padding-bottom-20"><b>Lottery Betting Event:</b> Mini Lotto</p>
						<p><b>Ball Pool Range:</b> Numbers drawn are from a pool of 1 to 39</p>
						<p><b>Underlying Lottery:</b> Gulfticket-hosted draw using Smartplay RNG and mechanical draw systems</p>
						<p><b>Underlying Lottery Operator:</b> Future I Tech System Ltd (licensed by the Gambling Control Authority, Samoa)</p>

						<div class="table">
							<ul class="transTble transTble2">
								<li>
									<div class="w-40 text-left">Prize Category</div>
									<div class="w-15 text-left">Balls Matched</div>
									<div class="w-15 text-left">Odds</div>
									<div class="w-15 text-left">No of Combinations</div>
									<div class="w-15 text-left">Prize Value (USD)</div>
								</li>
								<li>
									<div class="w-40">Type A</div>
									<div class="w-15">5</div>
									<div class="w-15">1 in 575,757</div>
									<div class="w-15">1</div>
									<div class="w-15">$100,000*</div>
								</li>
								<li>
									<div class="w-40">Type B</div>
									<div class="w-15">4</div>
									<div class="w-15">1 in 3,386.81</div>
									<div class="w-15">170</div>
									<div class="w-15">$100</div>
								</li>
								<li>
									<div class="w-40">Type C</div>
									<div class="w-15">3</div>
									<div class="w-15">1 in 102.63</div>
									<div class="w-15">5,610</div>
									<div class="w-15">$1</div>
								</li>
								<li>
									<div class="w-40">Type C</div>
									<div class="w-15">2</div>
									<div class="w-15">1 in 9.62</div>
									<div class="w-15">59,840</div>
									<div class="w-15">$0.50</div>
								</li>
								<li>
									<div class="w-40">–</div>
									<div class="w-15">1</div>
									<div class="w-15">1 in 2.48</div>
									<div class="w-15">231,880</div>
									<div class="w-15">$0</div>
								</li>
							</ul>
						</div>



						<h2 class="headding1 padding-top-20">FAST LOTTO STRUCTURE</h2>
						<p class="padding-bottom-20"><b>Lottery Betting Event:</b> Fast Lotto</p>
						<p><b>Ball Pool Range:</b> Numbers drawn are from a pool of 1 to 42</p>
						<p><b>Underlying Lottery:</b> Gulfticket-hosted draw using Smartplay RNG and mechanical draw systems</p>
						<p><b>Underlying Lottery Operator:</b> Future I Tech System Ltd (licensed by the Gambling Control Authority, Samoa)</p>

						<div class="table">
							<ul class="transTble transTble2">
								<li>
									<div class="w-40 text-left">Prize Category</div>
									<div class="w-15 text-left">Balls Matched</div>
									<div class="w-15 text-left">Odds</div>
									<div class="w-15 text-left">No of Combinations</div>
									<div class="w-15 text-left">Prize Value (USD)</div>
								</li>
								<li>
									<div class="w-40">Type A</div>
									<div class="w-15">5</div>
									<div class="w-15">1 in 850,668</div>
									<div class="w-15">1</div>
									<div class="w-15">$300,000*</div>
								</li>
								<li>
									<div class="w-40">Type B</div>
									<div class="w-15">4</div>
									<div class="w-15">1 in 4,598.21</div>
									<div class="w-15">185</div>
									<div class="w-15">$300</div>
								</li>
								<li>
									<div class="w-40">Type C</div>
									<div class="w-15">3</div>
									<div class="w-15">1 in 127.73</div>
									<div class="w-15">6,660</div>
									<div class="w-15">$3</div>
								</li>
								<li>
									<div class="w-40">Type C</div>
									<div class="w-15">2</div>
									<div class="w-15">1 in 10.95</div>
									<div class="w-15">77,700</div>
									<div class="w-15">$1</div>
								</li>
								<li>
									<div class="w-40">–</div>
									<div class="w-15">1</div>
									<div class="w-15">1 in 2.58</div>
									<div class="w-15">330,225</div>
									<div class="w-15">$0</div>
								</li>
							</ul>
						</div>


						<h2 class="headding1 padding-top-20">MILLIONAIRE  LOTTO STRUCTURE</h2>
						<p class="padding-bottom-20"><b>Lottery Betting Event:</b> Millionaire  Lotto</p>
						<p><b>Ball Pool Range:</b> Numbers drawn are from a pool of 1 to 46</p>
						<p><b>Underlying Lottery:</b> Gulfticket-hosted draw using Smartplay RNG and mechanical draw systems</p>
						<p><b>Underlying Lottery Operator:</b> Future I Tech System Ltd (licensed by the Gambling Control Authority, Samoa)</p>

						<div class="table">
							<ul class="transTble transTble2">
								<li>
									<div class="w-40 text-left">Prize Category</div>
									<div class="w-15 text-left">Balls Matched</div>
									<div class="w-15 text-left">Odds</div>
									<div class="w-15 text-left">No of Combinations</div>
									<div class="w-15 text-left">Prize Value (USD)</div>
								</li>
								<li>
									<div class="w-40">Type A</div>
									<div class="w-15">5</div>
									<div class="w-15">1 in 1,370,754</div>
									<div class="w-15">1</div>
									<div class="w-15">$1,000,000*</div>
								</li>
								<li>
									<div class="w-40">Type B</div>
									<div class="w-15">4</div>
									<div class="w-15">1 in 6,686.60</div>
									<div class="w-15">205</div>
									<div class="w-15">$100</div>
								</li>
								<li>
									<div class="w-40">Type C</div>
									<div class="w-15">3</div>
									<div class="w-15">1 in 167.17</div>
									<div class="w-15">8,200</div>
									<div class="w-15">$10</div>
								</li>
								<li>
									<div class="w-40">Type C</div>
									<div class="w-15">2</div>
									<div class="w-15">1 in 12.86</div>
									<div class="w-15">106,600</div>
									<div class="w-15">$0.30</div>
								</li>
								<li>
									<div class="w-40">–</div>
									<div class="w-15">1</div>
									<div class="w-15">1 in 2.71</div>
									<div class="w-15">506,350</div>
									<div class="w-15">$0</div>
								</li>
							</ul>
						</div>



						<h2 class="headding1 padding-top-20">MULTI MILLION   LOTTO STRUCTURE</h2>
						<p class="padding-bottom-20"><b>Lottery Betting Event:</b> Multi Million  Lotto</p> 
						<p><b>Ball Pool Range:</b> Numbers drawn are from a pool of 1 to 39</p>
						<p><b>Underlying Lottery:</b> Gulfticket-hosted draw using Smartplay RNG and mechanical draw systems</p>
						<p><b>Underlying Lottery Operator:</b> Future I Tech System Ltd (licensed by the Gambling Control Authority, Samoa)</p>

						<div class="table">
							<ul class="transTble transTble2">
								<li>
									<div class="w-40 text-left">Prize Category</div>
									<div class="w-15 text-left">Balls Matched</div>
									<div class="w-15 text-left">Odds</div>
									<div class="w-15 text-left">No of Combinations</div>
									<div class="w-15 text-left">Prize Value (USD)</div>
								</li>
								<li>
									<div class="w-40">Type A</div>
									<div class="w-15">6</div>
									<div class="w-15">1 in 3,262,623</div>
									<div class="w-15">1</div>
									<div class="w-15">$3,000,000*</div>
								</li>
								<li>
									<div class="w-40">Type B</div>
									<div class="w-15">5</div>
									<div class="w-15">1 in 16,478</div>
									<div class="w-15">198</div>
									<div class="w-15">$3,000</div>
								</li>
								<li>
									<div class="w-40">Type C</div>
									<div class="w-15">4</div>
									<div class="w-15">1 in 411.95</div>
									<div class="w-15">7,920</div>
									<div class="w-15">$30</div>
								</li>
								<li>
									<div class="w-40">Type C</div>
									<div class="w-15">3</div>
									<div class="w-15">1 in 29.9</div>
									<div class="w-15">109,120</div>
									<div class="w-15">$3</div>
								</li>
								<li>
									<div class="w-40">Type C</div>
									<div class="w-15">2</div>
									<div class="w-15">1 in 5.32</div>
									<div class="w-15">613,800</div>
									<div class="w-15">$0.30</div>
								</li>
								<li>
									<div class="w-40">–</div>
									<div class="w-15">1</div>
									<div class="w-15">1 in 2.29</div>
									<div class="w-15">1,424,016</div>
									<div class="w-15">$0</div>
								</li>
							</ul>
						</div>



						<h2 class="headding1 padding-top-20">SUPER MEGA MILLION LOTTO STRUCTURE</h2>
						<p class="padding-bottom-20"><b>Ball Pool Range:</b> Numbers drawn are from a pool of 1 to 49</p>
						<p ><b>Lottery Betting Event:</b> Super Mega Million  Lotto</p>
						<p><b>Underlying Lottery:</b> Gulfticket-hosted draw using Smartplay RNG and mechanical draw systems</p>
						<p><b>Underlying Lottery Operator:</b> Future I Tech System Ltd (licensed by the Gambling Control Authority, Samoa)</p>
						
						
						<div class="table">
							<ul class="transTble transTble2">
								<li>
									<div class="w-40 text-left">Prize Category</div>
									<div class="w-15 text-left">Balls Matched</div>
									<div class="w-15 text-left">Odds</div>
									<div class="w-15 text-left">No of Combinations</div>
									<div class="w-15 text-left">Prize Value (USD)</div>
								</li>
								<li>
									<div class="w-40">Type A</div>
									<div class="w-15">6</div>
									<div class="w-15">1 in 13,983,816</div>
									<div class="w-15">1</div>
									<div class="w-15">$25,000,000*</div>
								</li>
								<li>
									<div class="w-40">Type B</div>
									<div class="w-15">5</div>
									<div class="w-15">1 in 54,201</div>
									<div class="w-15">258</div>
									<div class="w-15">$25,000</div>
								</li>
								<li>
									<div class="w-40">Type C</div>
									<div class="w-15">4</div>
									<div class="w-15">1 in 1,032.40</div>
									<div class="w-15">13,545</div>
									<div class="w-15">$250</div>
								</li>
								<li>
									<div class="w-40">Type C</div>
									<div class="w-15">3</div>
									<div class="w-15">1 in 56.66</div>
									<div class="w-15">246,820</div>
									<div class="w-15">$25</div>
								</li>
								<li>
									<div class="w-40">Type C</div>
									<div class="w-15">2</div>
									<div class="w-15">1 in 7.55</div>
									<div class="w-15">1,851,150</div>
									<div class="w-15">$2</div>
								</li>
								<li>
									<div class="w-40">–</div>
									<div class="w-15">1</div>
									<div class="w-15">1 in 2.42</div>
									<div class="w-15">5,775,588</div>
									<div class="w-15">$0</div>
								</li>
							</ul>
						</div>
						<p class="padding-top-20">If a lottery draw does not take place, or if no result is published or officially announced, all valid Bets on the affected Lottery Betting Event will remain active and will be automatically carried forward to the rescheduled draw. If there is no rescheduled draw, the Bets will stand for the next available relevant draw.</p>

						<h2 class="headding1 padding-top-20">SCHEDULE 2: Rules on Scratch Card Games</h2>
						<p>These Rules on Scratch Card Games form part of the Terms and Conditions of the User Agreement.</p>


						<h3 class="padding-bottom-20">INTRODUCTION</h3>
						<p>Gulfticket offers digital Scratch Card games powered by certified Random Number Generator (RNG) software. Players reveal hidden panels or symbols on a virtual card to win prizes based on predefined outcomes.</p>
						<p>Each Scratch Card game has its own game rules, payout table, and winning odds. Please refer to the individual game information page for details before playing.</p>
						<h3 class="padding-bottom-20">HOW TO PLAY</h3>
						<p>Users must have a verified Gulfticket account to participate in Scratch Card games.</p>
						<p>Players select a Scratch Card game, confirm the ticket price, and click or tap to reveal symbols.</p>
						<p>Prizes are awarded instantly if the symbols revealed meet the criteria specified in the game’s win table.</p>
						<p>The outcome of a Scratch Card is determined at the moment of purchase using RNG systems certified for fairness and compliance.</p>
						<h3 class="padding-bottom-20">PRIZE STRUCTURE</h3>
						<span>Each Scratch Card game may include one or more of the following prize tiers:</span>
						<div class="staticContLi">
							<ul>
								<li>Jackpot Prize – the highest possible payout on the card </li>
								<li>Fixed Cash Prizes – secondary tier payouts</li>
								<li>Free Card Prizes – non-cash rewards such as a free card or game credit </li>
							</ul>
						</div>
						<p>Odds, prize values, and availability may vary by game and are shown in the game info section.</p>

						<h3 class="padding-bottom-20">GAME FAIRNESS AND VALIDATION</h3>
						<p>All Scratch Card outcomes are generated through a secure and tested RNG system.</p>
						<p>In case of technical interruption or suspected malfunction, Gulfticket reserves the right to invalidate the session and refund the ticket price.</p>

						<h3 class="padding-bottom-20">RESPONSIBLE PLAY</h3>
						<p>Scratch Cards are intended as casual entertainment. We encourage users to set deposit or session limits via the Responsible Gaming settings.</p>
						<p>If any user is found to be abusing the system, using bots or scripts, or participating fraudulently, Gulfticket may suspend their account and void winnings.</p>
						<p>Below are official prize tables for upcoming scratch card games. These reflect payout distribution, sample numbers, and winning conditions. Game names will be finalized before public launch.</p>

						<h3 class="padding-bottom-20">Scratch Card Game 1 – (Suggested Name: Golden Match)</h3>
						<div class="staticContLi">
							<ul>
								<li>Ticket Price: $0.30</li>
								<li>Tickets Issued: 30,000</li>
							</ul>
							<div class="table">
								<ul class="transTble transTble2">
									<li>
										<div class="w-40 text-left">Prize Amount (USD)</div>
										<div class="w-15 text-left">Number of Winners</div>
										<div class="w-15 text-left">Match Type</div>
										<div class="w-15 text-left">Sample Numbers</div>
										<div class="w-15 text-left">Total Payout (USD)</div>
									</li>
									<li>
										<div class="w-40">$2,000</div>
										<div class="w-15">1</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">641</div>
										<div class="w-15">$2,000</div>
									</li>
									<li>
										<div class="w-40">$300</div>
										<div class="w-15">2</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">149</div>
										<div class="w-15">$600</div>
									</li>
									<li>
										<div class="w-40">$30</div>
										<div class="w-15">10</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">321, 492</div>
										<div class="w-15">$300</div>
									</li>
									<li>
										<div class="w-40">$0.75</div>
										<div class="w-15">2,000</div>
										<div class="w-15">2-digit</div>
										<div class="w-15">11, 37, 44, 79, 85</div>
										<div class="w-15">$1,500</div>
									</li>
									<li>
										<div class="w-40">$0.50</div>
										<div class="w-15">5,500</div>
										<div class="w-15">2-digit</div>
										<div class="w-15">33, 54, 68, 88, 92</div>
										<div class="w-15">$2,750</div>
									</li>
								</ul>
							</div>

						</div>

						<h3 class="padding-bottom-20">Scratch Card Game 2 – (Suggested Name: Treasure Ticket)</h3>
						<div class="staticContLi">
							<ul>
								<li>Ticket Price: $0.50</li>
								<li>Tickets Issued: 30,000</li>
							</ul>
							<div class="table">
								<ul class="transTble transTble2">
									<li>
										<div class="w-40 text-left">Prize Amount (USD)</div>
										<div class="w-15 text-left">Number of Winners</div>
										<div class="w-15 text-left">Match Type</div>
										<div class="w-15 text-left">Sample Numbers</div>
										<div class="w-15 text-left">Total Payout (USD)</div>
									</li>
									<li>
										<div class="w-40">$3,000</div>
										<div class="w-15">1</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">827</div>
										<div class="w-15">$3,000</div>
									</li>
									<li>
										<div class="w-40">$30</div>
										<div class="w-15">15</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">148, 567</div>
										<div class="w-15">$450</div>
									</li>
									<li>
										<div class="w-40">$5,000</div>
										<div class="w-15">1</div>
										<div class="w-15">2-digit</div>
										<div class="w-15">11, 13, 34, 51, 72</div>
										<div class="w-15">$5,000</div>
									</li>
									<li>
										<div class="w-40">$0.50</div>
										<div class="w-15">6,000</div>
										<div class="w-15">2-digit</div>
										<div class="w-15">26, 46, 66, 85, 98</div>
										<div class="w-15">$3,000</div>
									</li>
								</ul>
							</div>

						</div>

						<h3 class="padding-bottom-20">Scratch Card Game 3 – (Suggested Name: Lucky One)</h3>
						<div class="staticContLi">
							<ul>
								<li>Ticket Price: $1.00</li>
								<li>Tickets Issued: 30,000</li>
							</ul>

							<div class="table">
								<ul class="transTble transTble2">
									<li>
										<div class="w-40 text-left">Prize Amount (USD)</div>
										<div class="w-15 text-left">Number of Winners</div>
										<div class="w-15 text-left">Match Type</div>
										<div class="w-15 text-left">Sample Numbers</div>
										<div class="w-15 text-left">Total Payout (USD)</div>
									</li>
									<li>
										<div class="w-40">$10,000</div>
										<div class="w-15">1</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">567</div>
										<div class="w-15">$10,000</div>
									</li>
									<li>
										<div class="w-40">$100</div>
										<div class="w-15">10</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">258, 937</div>
										<div class="w-15">$1,000</div>
									</li>
									<li>
										<div class="w-40">$1.50</div>
										<div class="w-15">4,000</div>
										<div class="w-15">2-digit</div>
										<div class="w-15">124, 421</div>
										<div class="w-15">$6,000</div>
									</li>
									<li>
										<div class="w-40">$1</div>
										<div class="w-15">5,000</div>
										<div class="w-15">2-digit</div>
										<div class="w-15">26, 46, 66, 85, 98</div>
										<div class="w-15">$5,000</div>
									</li>
								</ul>
							</div>

						</div>

						<h3 class="padding-bottom-20">Scratch Card Game 4 – (Suggested Name: Super Scratch10)</h3>
						<div class="staticContLi">
							<ul>
								<li>Ticket Price: $1.50</li>
								<li>Tickets Issued: 30,000</li>
							</ul>

							<div class="table">
								<ul class="transTble transTble2">
									<li>
										<div class="w-40 text-left">Prize Amount (USD)</div>
										<div class="w-15 text-left">Number of Winners</div>
										<div class="w-15 text-left">Match Type</div>
										<div class="w-15 text-left">Sample Numbers</div>
										<div class="w-15 text-left">Total Payout (USD)</div>
									</li>
									<li>
										<div class="w-40">$10,000</div>
										<div class="w-15">1</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">567</div>
										<div class="w-15">$10,000</div>
									</li>
									<li>
										<div class="w-40">$1,000</div>
										<div class="w-15">3</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">121, 137, 316</div>
										<div class="w-15">$3,000</div>
									</li>
									<li>
										<div class="w-40">$100</div>
										<div class="w-15">15</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">442, 505, 721</div>
										<div class="w-15">$1,500</div>
									</li>
									<li>
										<div class="w-40">$75</div>
										<div class="w-15">15</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">220, 641, 820</div>
										<div class="w-15">$1,125</div>
									</li>
									<li>
										<div class="w-40">$50</div>
										<div class="w-15">30</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">507, 779, 890</div>
										<div class="w-15">$1,500</div>
									</li>
									<li>
										<div class="w-40">$25</div>
										<div class="w-15">100</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">774, 889, 909</div>
										<div class="w-15">$2,500</div>
									</li>
									<li>
										<div class="w-40">$5</div>
										<div class="w-15">1,000</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">420, 566, 797</div>
										<div class="w-15">$5,000</div>
									</li>
									<li>
										<div class="w-40">$1.50</div>
										<div class="w-15">6,500</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">160, 206, 309</div>
										<div class="w-15">$9,750</div>
									</li>
								</ul>
							</div>

						</div>

						<h3 class="padding-bottom-20">Scratch Card Game 5 – (Suggested Name: Dream Match)</h3>
						<div class="staticContLi">
							<ul>
								<li>Ticket Price: $1.00</li>
								<li>Tickets Issued: 30,000</li>
							</ul>

							<div class="table">
								<ul class="transTble transTble2">
									<li>
										<div class="w-40 text-left">Prize Amount (USD)</div>
										<div class="w-15 text-left">Number of Winners</div>
										<div class="w-15 text-left">Match Type</div>
										<div class="w-15 text-left">Sample Numbers</div>
										<div class="w-15 text-left">Total Payout (USD)</div>
									</li>
									<li>
										<div class="w-40">$10,000</div>
										<div class="w-15">1</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">111</div>
										<div class="w-15">$10,000</div>
									</li>
									<li>
										<div class="w-40">$500</div>
										<div class="w-15">3</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">269, 420, 925</div>
										<div class="w-15">$1,500</div>
									</li>
									<li>
										<div class="w-40">$150</div>
										<div class="w-15">3</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">142, 327, 620</div>
										<div class="w-15">$450</div>
									</li>
									<li>
										<div class="w-40">$100</div>
										<div class="w-15">3</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">459, 661, 725</div>
										<div class="w-15">$300</div>
									</li>
									<li>
										<div class="w-40">$75</div>
										<div class="w-15">3</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">121, 552, 823</div>
										<div class="w-15">$225</div>
									</li>
									<li>
										<div class="w-40">$50</div>
										<div class="w-15">3</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">332, 441, 823</div>
										<div class="w-15">$150</div>
									</li>
									<li>
										<div class="w-40">$2.50</div>
										<div class="w-15">100</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">767, 892, 903</div>
										<div class="w-15">$250</div>
									</li>
									<li>
										<div class="w-40">$1</div>
										<div class="w-15">6,000</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">113, 212, 517</div>
										<div class="w-15">$6,000</div>
									</li>
									<li>
										<div class="w-40">$1</div>
										<div class="w-15">3,000</div>
										<div class="w-15">3-digit</div>
										<div class="w-15">501, 622, 702, 802</div>
										<div class="w-15">$3,000</div>
									</li>
								</ul>
							</div>

						</div>

						<h3 class="padding-bottom-20">Christmas/Santa</h3>
						<div class="staticContLi">
							<ul>
								<li>Ticket Price: $0.30</li>
								<li>Tickets Issued: 5,000,000</li>
							</ul>

							<div class="table">
								<ul class="transTble transTble2">
									<li>
										<div class="w-40 text-left">Tier</div>
										<div class="w-15 text-left">Combinations</div>
										<div class="w-15 text-left">Prize Value (USD)</div>
										<div class="w-15 text-left">Total Payout (USD)</div>
										{/* <div class="w-15 text-left">Ticket Price</div> */}
									</li>
									<li>
										<div class="w-40">1</div>
										<div class="w-15">1</div>
										<div class="w-15">$24,000</div>
										<div class="w-15">$24,000</div>
										{/* <div class="w-15">$0.30</div> */}
									</li>
									<li>
										<div class="w-40">2</div>
										<div class="w-15">2</div>
										<div class="w-15">$2,400</div>
										<div class="w-15">$4,800</div>
										{/* <div class="w-15">$0.30</div> */}
									</li>
									<li>
										<div class="w-40">3</div>
										<div class="w-15">100</div>
										<div class="w-15">$240</div>
										<div class="w-15">$24,000</div>
										{/* <div class="w-15">$0.30</div> */}
									</li>
									<li>
										<div class="w-40">4</div>
										<div class="w-15">500</div>
										<div class="w-15">$30</div>
										<div class="w-15">$15,000</div>
										{/* <div class="w-15">$0.30</div> */}
									</li>
									<li>
										<div class="w-40">5</div>
										<div class="w-15">5,000</div>
										<div class="w-15">$6</div>
										<div class="w-15">$30,000</div>
										{/* <div class="w-15">$0.30</div> */}
									</li>
									<li>
										<div class="w-40">6</div>
										<div class="w-15">50,000</div>
										<div class="w-15">$2.10</div>
										<div class="w-15">$105,000</div>
										{/* <div class="w-15">$0.30</div> */}
									</li>
									<li>
										<div class="w-40">7</div>
										<div class="w-15">100,000</div>
										<div class="w-15">$1.20</div>
										<div class="w-15">$120,000</div>
										{/* <div class="w-15">$0.30</div> */}
									</li>
									<li>
										<div class="w-40">8</div>
										<div class="w-15">200,000</div>
										<div class="w-15">$0.90</div>
										<div class="w-15">$180,000</div>
										{/* <div class="w-15">$0.30</div> */}
									</li>
									<li>
										<div class="w-40">9</div>
										<div class="w-15">450,000</div>
										<div class="w-15">$0.30</div>
										<div class="w-15">$135,000</div>
										{/* <div class="w-15">$0.30</div> */}
									</li>
									<li>
										<div class="w-40">10</div>
										<div class="w-15">900,000</div>
										<div class="w-15">$0.15</div>
										<div class="w-15">$135,000</div>
										{/* <div class="w-15">$0.30</div> */}
									</li>
								</ul>
							</div>

						</div>

						<h3 class="padding-bottom-20">Cricket Hatrick</h3>
						<div class="staticContLi">
							<ul>
								<li>Ticket Price: $0.15</li>
								<li>Tickets Issued: 130,000</li>
							</ul>

							<div class="table">
								<ul class="transTble transTble2">
									<li>
										<div class="w-40 text-left">Tier</div>
										<div class="w-15 text-left">Combinations</div>
										<div class="w-15 text-left">Prize Value (USD)</div>
										<div class="w-15 text-left">Total Payout (USD)</div>
										{/* <div class="w-15 text-left">Ticket Price</div> */}
									</li>
									<li>
										<div class="w-40">1</div>
										<div class="w-15">1</div>
										<div class="w-15">$1,500</div>
										<div class="w-15">$1,500</div>
										{/* <div class="w-15">$0.15</div> */}
									</li>
									<li>
										<div class="w-40">2</div>
										<div class="w-15">2</div>
										<div class="w-15">$500</div>
										<div class="w-15">$1,000</div>
										{/* <div class="w-15">$0.15</div> */}
									</li>
									<li>
										<div class="w-40">3</div>
										<div class="w-15">4</div>
										<div class="w-15">$200</div>
										<div class="w-15">$800</div>
										{/* <div class="w-15">$0.15</div> */}
									</li>
									<li>
										<div class="w-40">4</div>
										<div class="w-15">7</div>
										<div class="w-15">$100</div>
										<div class="w-15">$700</div>
										{/* <div class="w-15">$0.15</div> */}
									</li>
									<li>
										<div class="w-40">5</div>
										<div class="w-15">35</div>
										<div class="w-15">$10</div>
										<div class="w-15">$350</div>
										{/* <div class="w-15">$0.15</div> */}
									</li>
									<li>
										<div class="w-40">6</div>
										<div class="w-15">150</div>
										<div class="w-15">$5</div>
										<div class="w-15">$750</div>
										{/* <div class="w-15">$0.15</div> */}
									</li>
									<li>
										<div class="w-40">7</div>
										<div class="w-15">600</div>
										<div class="w-15">$2</div>
										<div class="w-15">$1,200</div>
										{/* <div class="w-15">$0.15</div> */}
									</li>
									<li>
										<div class="w-40">8</div>
										<div class="w-15">2,000</div>
										<div class="w-15">$1</div>
										<div class="w-15">$2,000</div>
										{/* <div class="w-15">$0.15</div> */}
									</li>
									<li>
										<div class="w-40">9</div>
										<div class="w-15">12,000</div>
										<div class="w-15">$0.25</div>
										<div class="w-15">$3,000</div>
										{/* <div class="w-15">$0.15</div> */}
									</li>
									<li>
										<div class="w-40">10</div>
										<div class="w-15">22,000</div>
										<div class="w-15">$0.05</div>
										<div class="w-15">$1,100</div>
										{/* <div class="w-15">$0.15</div> */}
									</li>
								</ul>
							</div>

						</div>

						<h3 class="padding-bottom-20">Pet Race</h3>
						<div class="staticContLi">
							<ul>
								<li>Ticket Price: $0.10</li>
								<li>Tickets Issued: 100,000</li>
							</ul>

							<div class="table">
								<ul class="transTble transTble2">
									<li>
										<div class="w-40 text-left">Tier</div>
										<div class="w-15 text-left">Combinations</div>
										<div class="w-15 text-left">Prize Value (USD)</div>
										<div class="w-15 text-left">Total Payout (USD)</div>
										{/* <div class="w-15 text-left">Ticket Price</div> */}
									</li>
									<li>
										<div class="w-40">1</div>
										<div class="w-15">1</div>
										<div class="w-15">$1,000</div>
										<div class="w-15">$1,000</div>
										{/* <div class="w-15">$0.10</div> */}
									</li>
									<li>
										<div class="w-40">2</div>
										<div class="w-15">2</div>
										<div class="w-15">$200</div>
										<div class="w-15">$400</div>
										{/* <div class="w-15">$/0.10</div> */}
									</li>
									<li>
										<div class="w-40">3</div>
										<div class="w-15">3</div>
										<div class="w-15">$100</div>
										<div class="w-15">$300</div>
										{/* <div class="w-15">$0.10</div> */}
									</li>
									<li>
										<div class="w-40">4</div>
										<div class="w-15">4</div>
										<div class="w-15">$50</div>
										<div class="w-15">$200</div>
										{/* <div class="w-15">$0.10</div> */}
									</li>
									<li>
										<div class="w-40">5</div>
										<div class="w-15">15</div>
										<div class="w-15">$20</div>
										<div class="w-15">$300</div>
										{/* <div class="w-15">$0.10</div> */}
									</li>
									<li>
										<div class="w-40">6</div>
										<div class="w-15">100</div>
										<div class="w-15">$2</div>
										<div class="w-15">$200</div>
										{/* <div class="w-15">$0.10</div> */}
									</li>
									<li>
										<div class="w-40">7</div>
										<div class="w-15">700</div>
										<div class="w-15">$0.50</div>
										<div class="w-15">$350</div>
										{/* <div class="w-15">$0.10</div> */}
									</li>
									<li>
										<div class="w-40">8</div>
										<div class="w-15">3,750</div>
										<div class="w-15">$0.30</div>
										<div class="w-15">$1,125</div>
										{/* <div class="w-15">$0.10</div> */}
									</li>
									<li>
										<div class="w-40">9</div>
										<div class="w-15">8,500</div>
										<div class="w-15">$0.10</div>
										<div class="w-15">$850</div>
										{/* <div class="w-15">$0.10</div> */}
									</li>
									<li>
										<div class="w-40">10</div>
										<div class="w-15">15,000</div>
										<div class="w-15">$0.02</div>
										<div class="w-15">$300</div>
										{/* <div class="w-15">$0.10</div> */}
									</li>
								</ul>
							</div>

						</div>

						<h3 class="padding-bottom-20">Valentines Day</h3>
						<div class="staticContLi">
							<ul>
								<li>Ticket Price: $0.50</li>
								<li>Tickets Issued: 7,000,000</li>
							</ul>
							<div class="table">
								<ul class="transTble transTble2">
									<li>
										<div class="w-40 text-left">Tier</div>
										<div class="w-15 text-left">Combinations</div>
										<div class="w-15 text-left">Prize Value (USD)</div>
										<div class="w-15 text-left">Total Payout (USD)</div>
									</li>
									<li>
										<div class="w-40">1</div>
										<div class="w-15">1</div>
										<div class="w-15">$50,000</div>
										<div class="w-15">$50,000</div>
									</li>
									<li>
										<div class="w-40">2</div>
										<div class="w-15">2</div>
										<div class="w-15">$5,000</div>
										<div class="w-15">$10,000</div>
									</li>
									<li>
										<div class="w-40">3</div>
										<div class="w-15">15</div>
										<div class="w-15">$500</div>
										<div class="w-15">$7,500</div>
									</li>
									<li>
										<div class="w-40">4</div>
										<div class="w-15">150</div>
										<div class="w-15">$50</div>
										<div class="w-15">$7,500</div>
									</li>
									<li>
										<div class="w-40">5</div>
										<div class="w-15">4,000</div>
										<div class="w-15">$10</div>
										<div class="w-15">$40,000</div>
									</li>
									<li>
										<div class="w-40">6</div>
										<div class="w-15">16,000</div>
										<div class="w-15">$5</div>
										<div class="w-15">$80,000</div>
									</li>
									<li>
										<div class="w-40">7</div>
										<div class="w-15">90,000</div>
										<div class="w-15">$2</div>
										<div class="w-15">$180,000</div>
									</li>
									<li>
										<div class="w-40">8</div>
										<div class="w-15">350,000</div>
										<div class="w-15">$1.50</div>
										<div class="w-15">$525,000</div>
									</li>
									<li>
										<div class="w-40">9</div>
										<div class="w-15">700,000</div>
										<div class="w-15">$0.75</div>
										<div class="w-15">$525,000</div>
									</li>
									<li>
										<div class="w-40">10</div>
										<div class="w-15">1,300,000</div>
										<div class="w-15">$0.25</div>
										<div class="w-15">$325,000</div>
									</li>
								</ul>
							</div>


						</div>

						<h3 class="padding-bottom-20">Charity</h3>
						<div class="staticContLi">
							<ul>
								<li>Ticket Price: $1.00</li>
								<li>Tickets Issued: 2,000,000</li>
							</ul>
							<div class="table">
								<ul class="transTble transTble2">
									<li>
										<div class="w-40 text-left">Tier</div>
										<div class="w-15 text-left">Combinations</div>
										<div class="w-15 text-left">Prize Value (USD)</div>
										<div class="w-15 text-left">Total Payout (USD)</div>
									</li>
									<li>
										<div class="w-40">1</div>
										<div class="w-15">1</div>
										<div class="w-15">$50,000</div>
										<div class="w-15">$50,000</div>
									</li>
									<li>
										<div class="w-40">2</div>
										<div class="w-15">16</div>
										<div class="w-15">$500</div>
										<div class="w-15">$8,000</div>
									</li>
									<li>
										<div class="w-40">3</div>
										<div class="w-15">400</div>
										<div class="w-15">$25</div>
										<div class="w-15">$10,000</div>
									</li>
									<li>
										<div class="w-40">4</div>
										<div class="w-15">1,000</div>
										<div class="w-15">$10</div>
										<div class="w-15">$10,000</div>
									</li>
									<li>
										<div class="w-40">5</div>
										<div class="w-15">1,000</div>
										<div class="w-15">$6</div>
										<div class="w-15">$6,000</div>
									</li>
									<li>
										<div class="w-40">6</div>
										<div class="w-15">4,000</div>
										<div class="w-15">$5</div>
										<div class="w-15">$20,000</div>
									</li>
									<li>
										<div class="w-40">7</div>
										<div class="w-15">20,000</div>
										<div class="w-15">$4</div>
										<div class="w-15">$80,000</div>
									</li>
									<li>
										<div class="w-40">8</div>
										<div class="w-15">64,000</div>
										<div class="w-15">$2.50</div>
										<div class="w-15">$160,000</div>
									</li>
									<li>
										<div class="w-40">9</div>
										<div class="w-15">32,000</div>
										<div class="w-15">$2</div>
										<div class="w-15">$64,000</div>
									</li>
									<li>
										<div class="w-40">10</div>
										<div class="w-15">168,000</div>
										<div class="w-15">$1.50</div>
										<div class="w-15">$252,000</div>
									</li>
									<li>
										<div class="w-40">11</div>
										<div class="w-15">240,000</div>
										<div class="w-15">$1</div>
										<div class="w-15">$240,000</div>
									</li>
									<li>
										<div class="w-40">12</div>
										<div class="w-15">200,000</div>
										<div class="w-15">$0.50</div>
										<div class="w-15">$100,000</div>
									</li>
								</ul>
							</div>

						</div>

						<h3 class="padding-bottom-20">Happy Birthday</h3>
						<div class="staticContLi">
							<ul>
								<li>Ticket Price: $1.00</li>
								<li>Tickets Issued: 2,000,000</li>
							</ul>
							<div class="table">
								<ul class="transTble transTble2">
									<li>
										<div class="w-40 text-left">Tier</div>
										<div class="w-15 text-left">Combinations</div>
										<div class="w-15 text-left">Prize Value (USD)</div>
										<div class="w-15 text-left">Total Payout (USD)</div>
									</li>
									<li>
										<div class="w-40">1</div>
										<div class="w-15">1</div>
										<div class="w-15">$10,000</div>
										<div class="w-15">$10,000</div>
									</li>
									<li>
										<div class="w-40">2</div>
										<div class="w-15">2</div>
										<div class="w-15">$5,000</div>
										<div class="w-15">$10,000</div>
									</li>
									<li>
										<div class="w-40">3</div>
										<div class="w-15">5</div>
										<div class="w-15">$2,500</div>
										<div class="w-15">$12,500</div>
									</li>
									<li>
										<div class="w-40">4</div>
										<div class="w-15">10</div>
										<div class="w-15">$500</div>
										<div class="w-15">$5,000</div>
									</li>
									<li>
										<div class="w-40">5</div>
										<div class="w-15">100</div>
										<div class="w-15">$100</div>
										<div class="w-15">$10,000</div>
									</li>
									<li>
										<div class="w-40">6</div>
										<div class="w-15">1,000</div>
										<div class="w-15">$25</div>
										<div class="w-15">$25,000</div>
									</li>
									<li>
										<div class="w-40">7</div>
										<div class="w-15">10,000</div>
										<div class="w-15">$5</div>
										<div class="w-15">$50,000</div>
									</li>
									<li>
										<div class="w-40">8</div>
										<div class="w-15">100,000</div>
										<div class="w-15">$3</div>
										<div class="w-15">$300,000</div>
									</li>
									<li>
										<div class="w-40">9</div>
										<div class="w-15">250,000</div>
										<div class="w-15">$1</div>
										<div class="w-15">$250,000</div>
									</li>
								</ul>
							</div>

						</div>

						<h3 class="padding-bottom-20">Gold Bar</h3>
						<div class="staticContLi">
							<ul>
								<li>Ticket Price: $1.00</li>
								<li>Tickets Issued: 10,000,000</li>
							</ul>
							<div class="table">
								<ul class="transTble transTble2">
									<li>
										<div class="w-40 text-left">Tier</div>
										<div class="w-15 text-left">Combinations</div>
										<div class="w-15 text-left">Prize Value (USD)</div>
										<div class="w-15 text-left">Total Payout (USD)</div>
									</li>
									<li>
										<div class="w-40">1</div>
										<div class="w-15">1</div>
										<div class="w-15">$100,000.00</div>
										<div class="w-15">$100,000</div>
									</li>
									<li>
										<div class="w-40">2</div>
										<div class="w-15">5</div>
										<div class="w-15">$10,000.00</div>
										<div class="w-15">$50,000</div>
									</li>
									<li>
										<div class="w-40">3</div>
										<div class="w-15">25</div>
										<div class="w-15">$1,000.00</div>
										<div class="w-15">$25,000</div>
									</li>
									<li>
										<div class="w-40">4</div>
										<div class="w-15">50</div>
										<div class="w-15">$500.00</div>
										<div class="w-15">$25,000</div>
									</li>
									<li>
										<div class="w-40">5</div>
										<div class="w-15">500</div>
										<div class="w-15">$100.00</div>
										<div class="w-15">$50,000</div>
									</li>
									<li>
										<div class="w-40">6</div>
										<div class="w-15">5,000</div>
										<div class="w-15">$50.00</div>
										<div class="w-15">$250,000</div>
									</li>
									<li>
										<div class="w-40">7</div>
										<div class="w-15">25,000</div>
										<div class="w-15">$10.00</div>
										<div class="w-15">$250,000</div>
									</li>
									<li>
										<div class="w-40">8</div>
										<div class="w-15">255,000</div>
										<div class="w-15">$5.00</div>
										<div class="w-15">$1,275,000</div>
									</li>
									<li>
										<div class="w-40">9</div>
										<div class="w-15">1,000,000</div>
										<div class="w-15">$2.00</div>
										<div class="w-15">$2,000,000</div>
									</li>
									<li>
										<div class="w-40">10</div>
										<div class="w-15">3,000,000</div>
										<div class="w-15">Freeplay</div>
										<div class="w-15">$3,000,000</div>
									</li>
								</ul>
							</div>

						</div>

						<h3 class="padding-bottom-20">Crorepati/Millionaire</h3>
						<div class="staticContLi">
							<ul>
								<li>Ticket Price: $4.00</li>
								<li>Tickets Issued: 50,000,000</li>
							</ul>
							<div class="table">
								<ul class="transTble transTble2">
									<li>
										<div class="w-40 text-left">Tier</div>
										<div class="w-15 text-left">Combinations</div>
										<div class="w-15 text-left">Prize Value (USD)</div>
										<div class="w-15 text-left">Total Payout (USD)</div>
									</li>
									<li>
										<div class="w-40">1</div>
										<div class="w-15">1</div>
										<div class="w-15">$1,000,000.00</div>
										<div class="w-15">$1,000,000</div>
									</li>
									<li>
										<div class="w-40">2</div>
										<div class="w-15">10</div>
										<div class="w-15">$10,000.00</div>
										<div class="w-15">$100,000</div>
									</li>
									<li>
										<div class="w-40">3</div>
										<div class="w-15">150</div>
										<div class="w-15">$2,000.00</div>
										<div class="w-15">$300,000</div>
									</li>
									<li>
										<div class="w-40">4</div>
										<div class="w-15">2,000</div>
										<div class="w-15">$200.00</div>
										<div class="w-15">$400,000</div>
									</li>
									<li>
										<div class="w-40">5</div>
										<div class="w-15">60,000</div>
										<div class="w-15">$40.00</div>
										<div class="w-15">$2,400,000</div>
									</li>
									<li>
										<div class="w-40">6</div>
										<div class="w-15">200,000</div>
										<div class="w-15">$24.00</div>
										<div class="w-15">$4,800,000</div>
									</li>
									<li>
										<div class="w-40">7</div>
										<div class="w-15">200,000</div>
										<div class="w-15">$20.00</div>
										<div class="w-15">$4,000,000</div>
									</li>
									<li>
										<div class="w-40">8</div>
										<div class="w-15">500,000</div>
										<div class="w-15">$12.00</div>
										<div class="w-15">$6,000,000</div>
									</li>
									<li>
										<div class="w-40">9</div>
										<div class="w-15">500,000</div>
										<div class="w-15">$10.00</div>
										<div class="w-15">$5,000,000</div>
									</li>
									<li>
										<div class="w-40">10</div>
										<div class="w-15">4,500,000</div>
										<div class="w-15">$8.00</div>
										<div class="w-15">$36,000,000</div>
									</li>
									<li>
										<div class="w-40">11</div>
										<div class="w-15">3,000,000</div>
										<div class="w-15">$6.00</div>
										<div class="w-15">$18,000,000</div>
									</li>
									<li>
										<div class="w-40">12</div>
										<div class="w-15">6,000,000</div>
										<div class="w-15">$5.00</div>
										<div class="w-15">$30,000,000</div>
									</li>
								</ul>
							</div>

						</div>
						<h2 class="headding1 padding-top-20">SCHEDULE 3: RNG GAMES RULES</h2>
						<p>RNG Games allow Users to participate in virtual games offered by Gulfticket on its Website, with winning numbers or outcomes generated by certified and tested random number generators (RNG).</p>
						<p>A User may participate in one or more RNG Games. The stake for our scratch cards is determined by the number of Instant Win Games (IWGs) purchased and displayed in the RNG Games section of the Website. All transactions are available in the “My Transactions” section. Gulfticket reserves the right to discontinue, modify, or introduce RNG Games at its sole discretion without obligation to provide reasons.</p>
						<p>Each RNG Game has a unique stake, prize range, and payout table. These payout tables are visible on the respective game pages within the Website.</p>
						<p>Unless specifically stated otherwise, only one prize may be won per RNG Game. Prizes may include instant cash, free RNG Games or spins, or physical goods as outlined in the game description.</p>
						<p>If a purchased RNG Game is not played within a two-week period, Gulfticket reserves the right to execute the game round on behalf of the User. Any resulting winnings will be credited to the User’s account.</p>
						<p>Users acknowledge they participate in RNG Games entirely at their own risk and cost.</p>
						<p>Gulfticket is not liable for any service interruptions, technical delays, or third-party disruptions impacting RNG Game performance.</p>
						<p>In the event of any error—technical or human—in the setup, delivery, or gameplay of an RNG Game, the round will be considered void. Any refunds are issued solely at Gulfticket’s discretion.</p>
						<p>Should a malfunction occur in any RNG Game, including but not limited to erroneous results, incorrect Return to Player (RTP), software faults, or exploitable glitches, any affected bets and winnings will be rendered null and void. Users must return any incorrectly awarded winnings to Gulfticket upon request. Subsequent plays funded by invalid winnings will also be nullified.</p>
						<p>Gulfticket may introduce RNG-based Bingo or other social games. Any specific rules for such games will be published separately on the Website and will form part of these Terms by reference.</p>
					</div>
					{/* : i18n.language === 'ml' ?
							<div className="addlPage scrollbar">
								<div className="addlpageCont">
									<p>
										ഓൺലൈൻ ഡ്രോ ഗെയിം വെബ്സൈറ്റായ ഗൾഫ് ടിക്കറ്റിലേക്ക് സ്വാഗതം, അവിടെ നിങ്ങൾക്ക് യഥാക്രമം 10 ദിർഹത്തിനും 30 ദിർഹത്തിനും വാട്ടർ ബോട്ടിലുകൾ വാങ്ങാനും ഫോർച്യൂൺ 5, സൂപ്പർ 6 എന്നിവയുടെ നറുക്കെടുപ്പ് ടിക്കറ്റുകൾ നേടാനും കഴിയും.
									</p>
									<p>
										ഗൾഫ് ടിക്കറ്റ് ഉപയോഗിക്കുന്നതിലൂടെ, ഇനിപ്പറയുന്ന നിബന്ധനകളും വ്യവസ്ഥകളും നിങ്ങൾ സമ്മതിക്കുന്നു:
									</p>
									<ul className="faqAccordian">
										<li>
											<a >യോഗ്യത</a>
											<p>ഗൾഫ് ടിക്കറ്റ് കളിക്കാൻ, നിങ്ങളുടെ രാജ്യത്തെ നിയമപരമായ പ്രായം അനുസരിച്ച് നിങ്ങൾക്ക് കുറഞ്ഞത് 18 വയസ്സോ പ്രായപൂർത്തിയായവരോ ആയിരിക്കണം.</p>
										</li>
										<li>
											<a >അക്കൗണ്ട് സൃഷ്ടിക്കുകയും ടിക്കറ്റ് വാങ്ങൽ എടുക്കുകയും ചെയ്യുക</a>
											<p>ഗൾഫ് ടിക്കറ്റ് കളിക്കാൻ നിങ്ങൾ ഒരു അക്കൗണ്ട് സൃഷ്ടിക്കുകയും ഒരു നറുക്കെടുപ്പ് ടിക്കറ്റ് വാങ്ങുകയും വേണം.</p>
											<p>നിങ്ങളുടെ അക്കൗണ്ട് വിവരങ്ങൾ കൃത്യവും കാലികവുമാണെന്ന് ഉറപ്പാക്കുന്നതിനുള്ള ഉത്തരവാദിത്തം നിങ്ങൾക്കാണ്.</p>
											<p>കൃത്യമല്ലാത്തതോ കാലഹരണപ്പെട്ടതോ ആയ അക്കൗണ്ട് വിവരങ്ങളുടെ ഫലമായി ഉണ്ടാകുന്ന ഏതെങ്കിലും നഷ്ടത്തിനോ നാശനഷ്ടങ്ങൾക്കോ ഗൾഫ് ടിക്കറ്റ് ഉത്തരവാദിയല്ല.</p>
											<p>നിങ്ങൾ കൃത്യമല്ലാത്തതോ തെറ്റിദ്ധരിപ്പിക്കുന്നതോ ആയ വിവരങ്ങൾ നൽകുകയാണെങ്കിൽ നിങ്ങളുടെ അക്കൗണ്ട് താൽക്കാലികമായി പ്രവർത്തനരഹിതമാക്കാനോ, അവസാനിപ്പിക്കാനോ ഉള്ള അവകാശം ഗൾഫ് ടിക്കറ്റിൽ നിക്ഷിപ്തമാണ്.</p>
										</li>
										<li>
											<a >പേയ്മെന്റ് രീതികൾ</a>
											<p>നറുക്കെടുപ്പ് ടിക്കറ്റ് വാങ്ങലുകൾക്കായി ഗൾഫ് ടിക്കറ്റ് ഇനിപ്പറയുന്ന പേയ്മെന്റ് രീതികൾ സ്വീകരിക്കുന്നു:</p>
											<ul>
												<li>
													<p>ക്രെഡിറ്റ് കാർഡ്</p>
												</li>
												<li>
													<p>ഡെബിറ്റ് കാർഡ്</p>
												</li>
												<li>
													<p>നെറ്റ് ബാങ്കിംഗ്</p>
												</li>
												<li>
													<p>മൊബൈൽ വാലറ്റ്</p>
												</li>
											</ul>
										</li>
										<li>
											<a >ഗൾഫ് ടിക്കറ്റ് നറുക്കെടുപ്പും വിജയ ടിക്കറ്റുകളും</a>
											<p>ഗൾഫ് ടിക്കറ്റ് വെബ്സൈറ്റിൽ പ്രഖ്യാപിച്ചതുപോലെ ഗൾഫ് ടിക്കറ്റ് നറുക്കെടുപ്പ് പതിവായി നടക്കുന്നു.</p>
											<p>റാഫിൾ വിജയ ടിക്കറ്റുകൾ ഒരു യാദൃശ്ചികമായ നമ്പർ ജനറേറ്റർ വഴി നിർണ്ണയിക്കപ്പെടുന്നു.</p>
											<p>നിങ്ങൾ കളിക്കുന്ന നറുക്കെടുപ്പ് ഗെയിമിനെ ആശ്രയിച്ച് വിജയിക്കാനുള്ള സാധ്യതകൾ വ്യത്യാസപ്പെടുന്നു.</p>
										</li>
										<li>
											<a >ഫലങ്ങൾ</a>
											<p>ഓരോ നറുക്കെടുപ്പിനും വിജയികളായ നമ്പറുകൾ വെബ് സൈറ്റിൽ ലഭ്യമാക്കുകയും ഓരോ നറുക്കെടുപ്പിന് ശേഷവും ഉപഭോക്തൃ പിന്തുണയിലേക്ക് വിളിക്കുകയും ചെയ്യും.. വിജയിക്കുന്ന സംഖ്യകൾ പരസ്യപ്പെടുത്തുന്നതിൽ ഞങ്ങളുടെ ഭാഗത്തുനിന്നുണ്ടായ ഏതെങ്കിലും പരാജയത്തിനോ അല്ലെങ്കിൽ വിജയിച്ച എൻട്രികളുടെ ഉടമകളെ അറിയിക്കുന്നതിൽ പരാജയപ്പെട്ടതിനോ നിങ്ങൾക്ക് നഷ്ടപരിഹാരത്തിന് ക്ലെയിം ഉണ്ടായിരിക്കില്ല; വിജയിക്കുന്ന നമ്പറുകൾക്കെതിരെ നിങ്ങളുടെ എൻട്രികൾ പരിശോധിക്കേണ്ടത് നിങ്ങളുടെ മാത്രം ഉത്തരവാദിത്തമാണ്.</p>
											<p>നഷ്ടപരിഹാരത്തിന് ക്ലെയിം ചെയ്യാൻ നിങ്ങൾക്ക് അർഹതയില്ല, കൂടാതെ ടൈപ്പോഗ്രാഫിക്കൽ, പ്രിന്റിംഗ് അല്ലെങ്കിൽ മറ്റേതെങ്കിലും തരത്തിലുള്ള ഏതെങ്കിലും പ്രഖ്യാപനത്തിലോ പ്രസിദ്ധീകരണത്തിലോ അല്ലെങ്കിൽ നറുക്കെടുപ്പിലെ സമ്മാനങ്ങളുടെ തുകയുടെ ഏതെങ്കിലും പ്രസിദ്ധീകരണത്തിലോ പ്രഖ്യാപനത്തിലോ അടങ്ങിയിരിക്കുന്ന പിശകുകൾക്ക് ഞങ്ങൾ ബാധ്യസ്ഥരല്ല (സമ്മാനങ്ങളിൽ അടയ്ക്കേണ്ട തുക അന്തിമമാക്കുന്നതിന് മുമ്പ് പ്രഖ്യാപനമോ പ്രസിദ്ധീകരണമോ നടത്തുന്ന സ്ഥലം ഉൾപ്പെടെ, പരിധിയില്ലാതെ)</p>
											<p>വെബ്സൈറ്റിൽ പ്രസിദ്ധീകരിച്ച വിജയ നമ്പറുകളും / അല്ലെങ്കിൽ മറ്റ് പ്രഖ്യാപനമോ പ്രസിദ്ധീകരണമോ സെൻട്രൽ കമ്പ്യൂട്ടർ സിസ്റ്റത്തിൽ അടങ്ങിയിരിക്കുന്ന ഔദ്യോഗിക വിജയ നമ്പറുകളും തമ്മിൽ പൊരുത്തക്കേട് ഉണ്ടെങ്കിൽ, രണ്ടാമത്തേത് നിലനിൽക്കും.</p>
											<p>വിജയികളായ എൻട്രികളുടെ അന്തിമ പരിശോധിച്ച എണ്ണം താൽക്കാലിക വിജയികളായ എൻട്രികളുടെ പ്രാരംഭ പരസ്യപ്പെടുത്തിയ എണ്ണത്തേക്കാൾ വ്യത്യസ്തമാണെങ്കിൽ, അത്തരം വിജയികൾക്ക് നൽകേണ്ട സമ്മാനത്തുക വ്യത്യാസപ്പെടാം.</p>
										</li>
										<li>
											<a >സമ്മാനം നേടുക</a>
											<a >റാഫിൾ നറുക്കെടുപ്പ്</a>
											<p>ഓരോ റാഫിൾ നറുക്കെടുപ്പിനും കുറഞ്ഞത് മൂന്ന് (3) വിജയികളായ റാഫിൾ ഐഡികൾ ഉണ്ടായിരിക്കും.</p>
											<p>വിജയികളായ റാഫിൾ ഐഡികളുമായി പൊരുത്തപ്പെടുന്ന റാഫിൾ ഐഡികൾ ഉള്ള പങ്കാളികൾക്ക് ഓരോരുത്തർക്കും 100,000 ദിർഹം (ഒരു ലക്ഷം ദിർഹം) അല്ലെങ്കിൽ ഞങ്ങളുടെ സ്വന്തം വിവേചനാധികാരത്തിൽ ഞങ്ങൾ നിർണ്ണയിക്കുകയും പ്രഖ്യാപിക്കുകയും ചെയ്യുന്ന മറ്റ് തുക ലഭിക്കും.
												ഏതൊരു റാഫിൾ സമ്മാനവും റാഫിൾ സമ്മാനം നേടിയ തീയതിയുടെ 60 കലണ്ടർ ദിവസത്തിനുള്ളിൽ ക്ലെയിം ചെയ്യണം. നിങ്ങൾ യുഎഇക്ക് പുറത്താണ് താമസിക്കുന്നതെങ്കിൽ, റാഫിൾ സമ്മാനം നേടുന്നതിന് യുഎഇയിൽ പങ്കെടുക്കാൻ നിങ്ങളോട് ആവശ്യപ്പെട്ടേക്കാം.
												ഞങ്ങൾ വിജ്ഞാപനം ചെയ്യുന്ന പബ്ലിക് റിലേഷൻസ്, മീഡിയ പ്രവർത്തനങ്ങൾ എന്നിവയിൽ നിങ്ങൾ പങ്കെടുക്കേണ്ടതുണ്ട്.
											</p>
										</li>
										<li>
											<a >വൻ നറുക്കെടുപ്പ്</a>
											<ul>
												<li>
													<p>എല്ലാ സമ്മാനങ്ങളും യുഎഇ ദിർഹത്തിൽ (എഇഡി) ആണ്</p>
													<p>മുൻകൂർ അറിയിപ്പ് കൂടാതെ ഈ നിബന്ധനകളും വ്യവസ്ഥകളും ഭേദഗതി ചെയ്യാനുള്ള അവകാശം ഡ്രോ മാനേജർക്ക് നിക്ഷിപ്തമാണ്.</p>
													<p>നറുക്കെടുപ്പിന്റെ മാനേജർക്ക് മാച്ച് പ്രൈസ് മാറ്റാനുള്ള വിവേചനാധികാരമുണ്ട്. മാച്ച് നാല് വിജയിക്കുന്ന എല്ലാ മത്സരാർത്ഥികൾക്കും മാച്ച് പ്രൈസ് തുല്യമായി വിഭജിക്കും.</p>
													<p>ബാധകമായ നിയമങ്ങൾ അനുസരിച്ച് സമ്മാനങ്ങൾ നികുതികൾക്ക് വിധേയമാണ്.</p>
												</li>
											</ul>
										</li>
										<li>
											<a >ഫോർച്യൂൺ 5</a>
											<p></p>
											<ul>
												<li>
													<p>മത്സരം രണ്ട് - നറുക്കെടുപ്പ് വിജയ സംഖ്യകളിൽ നിന്ന് ഏതെങ്കിലും ഒരു (1) ലൈനിലെ രണ്ട് (2) സംഖ്യകൾ പങ്കാളി ശരിയായി പൊരുത്തപ്പെടുത്തിയിട്ടുണ്ട്.</p>
												</li>
												<li>
													<p>മത്സരം മൂന്ന് - പങ്കെടുക്കുന്നയാൾ ഏതെങ്കിലും ഒരു (1) ലൈനിൽ നിന്ന് മൂന്ന് (3) സംഖ്യകൾ ശരിയായി പൊരുത്തപ്പെടുത്തിയിട്ടുണ്ട്;</p>
												</li>
												<li>
													<p>മത്സരം നാല് - നറുക്കെടുപ്പ് വിജയ സംഖ്യകളിൽ നിന്ന് ഏതെങ്കിലും ഒരു (1) ലൈനിലെ നാല് (4) സംഖ്യകൾ പങ്കാളി ശരിയായി പൊരുത്തപ്പെടുത്തിയിട്ടുണ്ട്; കൂടാതെ</p>
												</li>
												<li>
													<p>മത്സരം അഞ്ച് - ഗ്രാൻഡ് ഡ്രോ വിജയ നമ്പറുകളിൽ നിന്ന് ഏതെങ്കിലും ഒരു (1) ലൈനിലെ അഞ്ച് (5) നമ്പറുകളും പങ്കാളി ശരിയായി പൊരുത്തപ്പെടുത്തിയിട്ടുണ്ട്.</p>
												</li>
											</ul>
										</li>
										<li>
											<a >സൂപ്പർ 6</a>
											<ul>
												<li>
													<p>മത്സരം രണ്ട് - നറുക്കെടുപ്പ് വിജയ സംഖ്യകളിൽ നിന്ന് ഏതെങ്കിലും ഒരു (1) ലൈനിലെ രണ്ട് (2) സംഖ്യകൾ പങ്കാളി ശരിയായി മാച്ച് ചെയ്തിട്ടുണ്ട്.</p>
												</li>
												<li>
													<p>മത്സരം മൂന്ന് - പങ്കെടുക്കുന്നയാൾ ഏതെങ്കിലും ഒരു (1) ലൈനിൽ നിന്ന് മൂന്ന് (3) സംഖ്യകൾ ശരിയായി മാച്ച് ചെയ്തിട്ടുണ്ട്;</p>
												</li>
												<li>
													<p>മത്സരം നാല് - നറുക്കെടുപ്പ് വിജയ സംഖ്യകളിൽ നിന്ന് ഏതെങ്കിലും ഒരു (1) ലൈനിലെ നാല് (4) സംഖ്യകൾ പങ്കാളി ശരിയായി മാച്ച് ചെയ്തിട്ടുണ്ട്; കൂടാതെ</p>
												</li>
												<li>
													<p>അഞ്ചാം മത്സരം - രണ്ടാം നറുക്കെടുപ്പ് വിജയ സംഖ്യകളിൽ നിന്ന് ഏതെങ്കിലും ഒരു (1) ലൈനിലെ അഞ്ച് (5) നമ്പറുകളും പങ്കാളി ശരിയായി മാച്ച് ചെയ്തിട്ടുണ്ട്.</p>
												</li>
												<li>
													<p>മാച്ച് ആറ് - ഗ്രാൻഡ് ഡ്രോ വിജയ നമ്പറുകളിൽ നിന്ന് ഏതെങ്കിലും ഒരു (1) ലൈനിലെ അഞ്ച് (6) നമ്പറുകളും പങ്കാളി ശരിയായി മാച്ച് ചെയ്തിട്ടുണ്ട്.</p>
												</li>
											</ul>
											<p>ഫോർച്യൂൺ 5 ന് അഞ്ച് മത്സരങ്ങൾക്ക് ഗ്രാൻഡ് നറുക്കെടുപ്പിന് 1,000,000 ദിർഹം (ഒരു ദശലക്ഷം ദിർഹം) സമ്മാനം ലഭിക്കും.</p>
											<p>സൂപ്പർ 6 മത്സരങ്ങൾക്ക് ഒരു ഗ്രാൻഡ് നറുക്കെടുപ്പിന് 100,000,000 ദിർഹം (100 മില്യൺ ദിർഹം) സമ്മാനമായി ലഭിക്കും.</p>
										</li>
										<li>
											<a >വിജയങ്ങൾ ക്ലെയിം ചെയ്യുന്നത്</a>
											<p>നറുക്കെടുപ്പ് ജയിച്ച് 30 ദിവസത്തിനുള്ളിൽ നിങ്ങൾ നിങ്ങളുടെ വിജയങ്ങൾ ക്ലെയിം ചെയ്യണം. ക്ലെയിം ചെയ്യാത്ത വിജയികൾ ഗൾഫ് ടിക്കറ്റിന് നഷ്ടമാകും. നിങ്ങളുടെ വിജയങ്ങൾ ക്ലെയിം ചെയ്യുന്നതിന്, നിങ്ങളുടെ ഗൾഫ് ടിക്കറ്റ് അക്കൗണ്ടിലേക്ക് ലോഗിൻ ചെയ്ത് ഒരു ക്ലെയിം ഫോം സമർപ്പിക്കണം. ഗൾഫ് ടിക്കറ്റ് നിങ്ങളുടെ ക്ലെയിം പരിശോധിക്കുകയും 7 പ്രവൃത്തി ദിവസത്തിനുള്ളിൽ നിങ്ങളുടെ അക്കൗണ്ടിലേക്ക് നിങ്ങളുടെ വിജയങ്ങൾ നൽകുകയും ചെയ്യും. 100,000 ദിർഹത്തിന് മുകളിലുള്ള വിജയികൾക്ക് ബാങ്ക് ട്രാൻസ്ഫർ വഴി നൽകും. 100,000 ദിർഹത്തിൽ താഴെയുള്ള വിജയികൾക്ക് ബാങ്ക് ട്രാൻസ്ഫർ, ചെക്ക് വഴി പണം ലഭിക്കും.</p>
										</li>
										<li>
											<a >നികുതികൾ</a>
											<p>ഗൾഫ് ടിക്കറ്റിൽ നിന്നുള്ള എല്ലാ വിജയങ്ങളും യുഎഇ നികുതി നിയമങ്ങൾക്ക് വിധേയമാണ്. സർക്കാർ ചട്ടങ്ങൾ അനുസരിച്ച് നിങ്ങളുടെ രാജ്യത്ത് ഒരു അധിക നികുതിയും ബാധകമായേക്കാം.</p>
											<p>ഗൾഫ് ടിക്കറ്റ് നിങ്ങൾക്ക് നൽകുന്നതിനുമുമ്പ് നിങ്ങളുടെ വിജയങ്ങളിൽ നിന്ന് ബാധകമായ നികുതി പിടിച്ചുവയ്ക്കും.</p>
										</li>
										<li>
											<a >ഉത്തരവാദിത്തമുള്ള ഗെയിമിംഗ്</a>
											<p>ഉത്തരവാദിത്തമുള്ള ഗെയിമിംഗിന് ഗൾഫ് ടിക്കറ്റ് പ്രതിജ്ഞാബദ്ധമാണ്. ഉത്തരവാദിത്തത്തോടെ കളിക്കാനും അവരുടെ ചെലവിന് പരിധി നിശ്ചയിക്കാനും ഞങ്ങൾ അംഗങ്ങളെ പ്രോത്സാഹിപ്പിക്കുന്നു.</p>
											<p>ഉത്തരവാദിത്തമുള്ള ഗെയിമിംഗിന് ഗൾഫ് ടിക്കറ്റ് പ്രതിജ്ഞാബദ്ധമാണ്. ഉത്തരവാദിത്തത്തോടെ കളിക്കാനും അവരുടെ ചെലവിന് പരിധി നിശ്ചയിക്കാനും ഞങ്ങൾ അംഗങ്ങളെ പ്രോത്സാഹിപ്പിക്കുന്നു.</p>
										</li>
										<li>
											<a >ബൗദ്ധിക സ്വത്തവകാശം</a>
											<p>ഗൾഫ് ടിക്കറ്റ് ലോഗോ, വ്യാപാരമുദ്രകൾ, പകർപ്പവകാശം എന്നിവയുൾപ്പെടെ ഗൾഫ് ടിക്കറ്റ് വെബ്സൈറ്റിലെ എല്ലാ ഉള്ളടക്കവും ഗൾഫ് ടിക്കറ്റിന്റെ സ്വത്താണ്.</p>
											<p>ഗൾഫ് ടിക്കറ്റിന്റെ രേഖാമൂലമുള്ള അനുമതിയില്ലാതെ ഏതെങ്കിലും ഗൾഫ് ടിക്കറ്റ് ബൗദ്ധിക സ്വത്ത് ഉപയോഗിക്കാൻ നിങ്ങൾക്ക് അനുവാദമില്ല.</p>
										</li>
										<li>
											<a >ഭരണ നിയമവും തർക്ക പരിഹാരവും</a>
											<p>ഈ നിബന്ധനകളും വ്യവസ്ഥകളും യുഎഇയിലെ നിയമങ്ങൾക്കനുസൃതമായി നിയന്ത്രിക്കുകയും വ്യാഖ്യാനിക്കുകയും ചെയ്യുന്നു. ഈ നിബന്ധനകളും വ്യവസ്ഥകളും മൂലം ഉണ്ടാകുന്ന ഏതൊരു തർക്കവും യുഎഇയിലെ കോടതികൾ പരിഹരിക്കും.</p>
										</li>
										<li>
											<a >വ്യവസ്ഥകളിലും നിബന്ധനകളിലും വരുത്തിയ മാറ്റങ്ങൾ</a>
											<p>ഏത് സമയത്തും ഈ നിബന്ധനകളും വ്യവസ്ഥകളും മാറ്റാനുള്ള അവകാശം ഗൾഫ് ടിക്കറ്റിൽ നിക്ഷിപ്തമാണ്. ഞങ്ങൾ എന്തെങ്കിലും മാറ്റങ്ങൾ വരുത്തുകയാണെങ്കിൽ, അപ്ഡേറ്റുചെയ്ത നിബന്ധനകളും വ്യവസ്ഥകളും ഞങ്ങളുടെ വെബ് സൈറ്റിൽ പോസ്റ്റുചെയ്യും.</p>
										</li>
										<li>
											<a >ഞങ്ങളെ ബന്ധപ്പെടുക</a>
											<p>ഈ നിബന്ധനകളെയും വ്യവസ്ഥകളെയും കുറിച്ച് നിങ്ങൾക്ക് എന്തെങ്കിലും ചോദ്യങ്ങൾ ഉണ്ടെങ്കിൽ, ദയവായി ഞങ്ങളെ ബന്ധപ്പെടുക [helpdesk@gulfticket.com]</p>
											<p>ഗൾഫ് ടിക്കറ്റ് കളിച്ചതിന് നന്ദി!</p>
										</li>
										<li>
											<a >അധിക നിബന്ധനകളും വ്യവസ്ഥകളും</a>
											<p>നറുക്കെടുപ്പ് കളിക്കുന്നതിൽ നിന്നോ നിങ്ങളുടെ വിജയങ്ങൾ അവകാശപ്പെടുന്നതിൽ നിന്നോ നിങ്ങളെ തടഞ്ഞേക്കാവുന്ന ഏതെങ്കിലും സാങ്കേതിക ബുദ്ധിമുട്ടുകൾക്ക് ഗൾഫ് ടിക്കറ്റ് ഉത്തരവാദിയല്ല.</p>
											<p>ഏത് സമയത്തും ഏതെങ്കിലും ഗൾഫ് ടിക്കറ്റ് നറുക്കെടുപ്പ് റദ്ദാക്കാനോ താൽക്കാലികമായി നിർത്താനോ ഉള്ള അവകാശം ഗൾഫ് ടിക്കറ്റിൽ നിക്ഷിപ്തമാണ്.</p>
											<p>ഈ നിബന്ധനകളും വ്യവസ്ഥകളും ലംഘിക്കുകയോ ഏതെങ്കിലും വഞ്ചനാപരമോ നിയമവിരുദ്ധമോ ആയ പ്രവർത്തനങ്ങളിൽ ഏർപ്പെടുകയോ ചെയ്താൽ ഏതെങ്കിലും കളിക്കാരനെ നറുക്കെടുപ്പ് കളിക്കുന്നതിൽ നിന്നോ അവരുടെ വിജയങ്ങൾ അവകാശപ്പെടുന്നതിൽ നിന്നോ അയോഗ്യരാക്കാനുള്ള അവകാശം ഗൾഫ് ടിക്കറ്റിൽ നിക്ഷിപ്തമാണ്.</p>
											<p>കളിക്കാരുടെ സ്വകാര്യത പരിരക്ഷിക്കാൻ ഗൾഫ് ടിക്കറ്റ് പ്രതിജ്ഞാബദ്ധമാണ്. നിങ്ങളുടെ വ്യക്തിഗത വിവരങ്ങൾ ഞങ്ങൾ എങ്ങനെ ശേഖരിക്കുകയും ഉപയോഗിക്കുകയും പങ്കിടുകയും ചെയ്യുന്നു എന്നതിനെ കുറിച്ചുള്ള കൂടുതൽ വിവരങ്ങൾക്ക് ഞങ്ങളുടെ സ്വകാര്യതാ നയം അവലോകനം ചെയ്യുക.</p>
										</li>
									</ul>
								</div>
							</div> : i18n.language === 'ar' ?
								<div className="addlPage scrollbar">
									<div className="addlpageCont">
										<p>
											مرحباً بك في تذكرة الخليج, موقع لعبة السحب عبر الإنترنت حيث يمكنك شراء زجاجات مياه بقيمة 10 دراهم و30 درهماً والحصول على تذاكر السحب لـFortune 5 وSuper 6 على التوالي.
										</p>
										<p>
											استخدامك لتذكرة الخليج فأنت توافق على الشروط والأحكام التالية
										</p>
										<ul className="faqAccordian">
											<li>
												<a >الأهلية</a>
												<p>للعب في تذكرة الخليج يجب أن يكون عمرك 18 عامًا على الأقل أو بالغًا حسب السن القانوني في بلدك.</p>
											</li>
											<li>
												<a >إنشاء الحساب وسحب شراء التذاكر</a>
												<p>يجب عليك إنشاء حساب وشراء تذكرة السحب للعب تذكرة الخليج.</p>
												<p>أنت مسؤول عن التأكد من أن معلومات حسابك دقيقة وحديثة.</p>
												<p>تذكرة الخليج ليست مسؤولة عن أي خسائر أو أضرار تتكبدها نتيجة لمعلومات الحساب غير الدقيقة أو القديمة.</p>
												<p>تحتفظ شركة Gulf Ticket بالحق في تعليق أو إنهاء حسابك إذا قدمت معلومات غير دقيقة أو مضللة.</p>
											</li>
											<li>
												<a >طرق الدفع</a>
												<p>تقبل تذكرة الخليج طرق الدفع التالية لشراء تذاكر السحب:</p>
												<ul>
													<li>
														<p>البطاقة الائتمانية</p>
													</li>
													<li>
														<p>بطاقة الصراف الآلي</p>
													</li>
													<li>
														<p>التحويل البنكي</p>
													</li>
													<li>
														<p>محفظة الجوال</p>
													</li>
												</ul>
											</li>
											<li>
												<a >السحب والفوز بتذكرة الخليج</a>
												<p>يتم إجراء السحوبات بشكل منتظم، كما هو معلن على موقع تذكرة الخليج.</p>
												<p>يتم تحديد التذاكر الفائزة بالسحب من خلال مولد أرقام عشوائي.</p>
												<p>تختلف احتمالات الفوز اعتمادًا على لعبة السحب التي تلعبها.</p>
											</li>
											<li>
												<a >النتائج</a>
												<p>سيتم توفير الأرقام الفائزة لكل سحب على الموقع الإلكتروني ومن خلال الاتصال بدعم العملاء بعد كل سحب. لن يكون لديك أي مطالبة بالتعويض عن أي فشل من جانبنا في نشر الأرقام الفائزة أو عدم إخطار حاملي الأرقام الفائزة إدخالات؛ تقع على عاتقك وحدك مسؤولية التحقق من إدخالاتك مقابل الأرقام الفائزة.</p>
												<p>لن يحق لك المطالبة بالتعويض، ولن نلتزم بأي أخطاء واردة في أي إعلان أو منشور، سواء كان مطبعيًا أو مطبوعًا أو غير ذلك أو أي منشور أو إعلان عن مبلغ الجوائز في السحب (بما في ذلك، بدون القيد، حيث يتم الإعلان أو النشر قبل الانتهاء من المبلغ الذي سيتم دفعه في الجوائز).</p>
												<p>في حالة وجود تناقض بين الأرقام الفائزة المنشورة على الموقع الإلكتروني و/أو أي إعلان أو منشور آخر والأرقام الفائزة الرسمية الموجودة على نظام الكمبيوتر المركزي، فإن الأخيرة هي التي تسود.</p>
												<p>في حالة اختلاف العدد النهائي الذي تم التحقق منه من المشاركات الفائزة عن العدد الأولي المُعلن عنه من المشاركات الفائزة المؤقتة، فقد تختلف أموال الجائزة المستحقة لهؤلاء الفائزين.</p>
											</li>
											<li>
												<a >الفوز بجائزة</a>
												<a >السحب</a>
												<p>سيكون هناك ما لا يقل عن ثلاثة (3) معرفات سحب فائزة لكل سحب.</p>
												<p>سيفوز كل من المشاركين الذين تتطابق معرفاتهم في السحب مع معرفات السحب الفائزة بمبلغ 100,000 درهم إماراتي (مائة ألف درهم) أو أي مبلغ آخر قد نحدده ونعلن عنه وفقًا لتقديرنا الخاص.</p>
												<p>يجب المطالبة بأي جائزة يانصيب في موعد لا يتجاوز 60 يومًا تقويميًا من تاريخ الفوز بجائزة السحب. إذا كنت تقيم خارج دولة الإمارات العربية المتحدة، فقد يُطلب منك الحضور إلى دولة الإمارات العربية المتحدة للمطالبة بجائزة السحب.</p>
												<p>قد يُطلب منك حضور أنشطة العلاقات العامة والإعلام التي أبلغناك بها.</p>
											</li>
											<li>
												<a >السحب الكبير</a>
												<ul>
													<li>
														<p>جميع الجوائز بالدرهم الإماراتي (AED).</p>
														<p>يحتفظ مدير السحب بالحق في تعديل هذه الشروط والأحكام دون إشعار مسبق.</p>
														<p>يمتلك مدير القرعة السلطة التقديرية لتغيير جائزة المباراة. سيتم تقسيم جائزة المباراة بالتساوي بين جميع المشاركين الفائزين في المباراة الرابعة</p>
														<p>تخضع الجوائز للضرائب وفقًا للقوانين المعمول بها.</p>
													</li>
												</ul>
											</li>
											<li>
												<a >الثروة 5</a>
												<p></p>
												<ul>
													<li>
														<p>المباراة الثانية - قام المشارك بمطابقة رقمين (2) بشكل صحيح في أي سطر (1) واحد من الأرقام الفائزة في السحب.</p>
													</li>
													<li>
														<p>المباراة الثالثة - قام المشارك بمطابقة ثلاثة (3) أرقام بشكل صحيح في أي سطر (1) واحد من الأرقام الفائزة في السحب؛</p>
													</li>
													<li>
														<p>المباراة الرابعة - قام المشارك بمطابقة أربعة (4) أرقام بشكل صحيح في أي سطر واحد (1) من الأرقام الفائزة في السحب؛ و</p>
													</li>
													<li>
														<p>المباراة الخامسة - قام المشارك بمطابقة جميع الأرقام الخمسة (5) بشكل صحيح في أي سطر واحد (1) من الأرقام الفائزة في السحب الكبير.</p>
													</li>
												</ul>
											</li>
											<li>
												<a >السوبر 6</a>
												<ul>
													<li>
														<p>المباراة الثانية - قام المشارك بمطابقة رقمين (2) بشكل صحيح في أي سطر (1) واحد من الأرقام الفائزة في السحب.</p>
													</li>
													<li>
														<p>المباراة الثالثة - قام المشارك بمطابقة ثلاثة (3) أرقام بشكل صحيح في أي سطر (1) واحد من الأرقام الفائزة في السحب؛</p>
													</li>
													<li>
														<p>المباراة الرابعة - قام المشارك بمطابقة أربعة (4) أرقام بشكل صحيح في أي سطر واحد (1) من الأرقام الفائزة في السحب؛ و</p>
													</li>
													<li>
														<p>المباراة الخامسة - قام المشارك بمطابقة جميع الأرقام الخمسة (5) بشكل صحيح في أي سطر واحد (1) من الأرقام الفائزة في السحب الثاني.</p>
													</li>
													<li>
														<p>المباراة السادسة - قام المشارك بمطابقة جميع الأرقام الخمسة (6) بشكل صحيح في أي سطر واحد (1) من الأرقام الفائزة في السحب الكبير.</p>
													</li>
												</ul>
												<p>بما يخص لعبة الثروة 5 ستحصل مباريات الأرقام الخمسة على الجائزة الكبرى بقيمة 1,000,000 درهم إماراتي (مليون درهم) في كل سحب كبير.</p>
												<p>بما يخص لعبة السوبر 6 ستحصل مباريات الأرقام الستة على الجائزة الكبرى بقيمة 100,000,000 درهم إماراتي (مائة مليون درهم) لكل سحب كبير.</p>
											</li>
											<li>
												<a >المطالبة بالجوائز</a>
												<p>يجب عليك المطالبة بجوائزك خلال 30 يومًا من الفوز بالسحب. سيتم مصادرة المكاسب غير المطالب بها إلى تذكرة الخليج. للمطالبة بأرباحك، يجب عليك تسجيل الدخول إلى حساب تذكرة الخليج الخاص بك وتقديم نموذج المطالبة. ستقوم تذكرة الخليج بالتحقق من مطالبتك ودفع أرباحك إلى حسابك خلال 7 أيام عمل. سيتم دفع المكاسب التي تزيد عن 100,000 درهم عن طريق التحويل المصرفي. يمكن دفع المكاسب التي تقل عن 100,000 درهم عن طريق التحويل المصرفي أو الشيك.</p>
											</li>
											<li>
												<a >الضرائب</a>
												<p>تخضع جميع المكاسب من تذكرة الخليج لقوانين الضرائب في دولة الإمارات العربية المتحدة. قد تكون هناك أيضًا ضريبة إضافية مطبقة في بلدك وفقًا للوائح الحكومية.</p>
												<p>سوف تقوم شركة تذكرة الخليج بخصم الضريبة المطبقة من أرباحك قبل دفعها لك.</p>
											</li>
											<li>
												<a >ألعاب مسؤولة</a>
												<p>تلتزم تذكرة الخليج بتقديم ألعاب بمسؤولية. نحن نشجع عملاؤنا على اللعب بمسؤولية ووضع حد لمصروفاتهم.</p>
												<p>إذا كانت لديك أي مشكلة مع الإسراف في الصرف، برجاء الاتصال بفريق دعم عملاء تذكرة الخليج للحصول على المساعدة.</p>
											</li>
											<li>
												<a >الملكية الفكرية</a>
												<p>جميع محتويات موقع تذكرة الخليج، بما في ذلك شعار تذكرة الخليج والعلامات التجارية وحقوق الطبع والنشر، هي ملك لشركة تذكرة الخليج.</p>
												<p>لا يجوز لك استخدام أي ملكية فكرية لتذكرة الخليج دون الحصول على إذن كتابي صريح من تذكرة الخليج.</p>
											</li>
											<li>
												<a >القانون الحاكم وحل النزاعات</a>
												<p>تخضع هذه الشروط والأحكام وتفسر وفقًا لقوانين دولة الإمارات العربية المتحدة.سيتم حل أي نزاعات تنشأ عن هذه الشروط والأحكام من قبل محاكم دولة الإمارات العربية المتحدة.</p>
											</li>
											<li>
												<a >التغييرات في الشروط والأحكام</a>
												<p>تحتفظ شركة تذكرة الخليج بالحق في تغيير هذه الشروط والأحكام في أي وقت.إذا أجرينا أي تغييرات، فسنقوم بنشر الشروط والأحكام المحدثة على موقعنا</p>
											</li>
											<li>
												<a >اتصل بنا</a>
												<p>إذا كان لديك أي أسئلة حول هذه الشروط والأحكام، يرجى الاتصال بنا على [helpdesk@gulfticket.com]</p>
												<p>شكرا للعب تذكرة الخليج!</p>
											</li>
											<li>
												<a >شروط وأحكام إضافية</a>
												<p>تذكرة الخليج ليست مسؤولة عن أي صعوبات فنية قد تمنعك من لعب القرعة أو المطالبة بأرباحك.</p>
												<p>تحتفظ شركة تذكرة الخليج بالحق في إلغاء أو تعليق أي سحب على تذكرة الخليج في أي وقت.</p>
												<p>تحتفظ شركة تذكرة الخليج بالحق في استبعاد أي لاعب من لعب السحب أو المطالبة بأرباحه إذا انتهك هذه الشروط والأحكام أو إذا شارك في أي نشاط احتيالي أو غير قانوني.</p>
												<p>تلتزم شركة تذكرة الخليج بحماية خصوصية لاعبيها. يرجى مراجعة سياسة الخصوصية الخاصة بنا للحصول على مزيد من المعلومات حول كيفية جمع معلوماتك الشخصية واستخدامها ومشاركتها.</p>
											</li>
										</ul>
									</div>
								</div> :
								<div className="addlPage scrollbar">
									<div className="addlpageCont">
										<p>آن لائن ڈرا گیم کی ویب سائٹ گلف ٹکٹ میں خوش آمدید جہاں آپ 10 اماراتی درہم اور 30 اماراتی درہم میں پانی کی بوتلیں خرید سکتے ہیں اور فورچیون  5 اور سوپر  6 کے لیے بالترتیب ڈرا ٹکٹ حاصل کر سکتے ہیں۔
										</p>
										<p>
											گلف ٹکٹ استعمال کرکے، آپ درج ذیل شرائط و ضوابط سے اتفاق کرتے ہیں:
										</p>
										<ul className="faqAccordian">
											<li>
												<a >اہلیت</a>
												<p>گلف ٹکٹ کھیلنے کے لیے، آپ کی عمر کم از کم 18 سال ہونی چاہیے یا آپ کو آپ کے ملک میں قانونی عمر کے مطابق بالغ ہونا چاہیے۔</p>
											</li>
											<li>
												<a >اکاؤنٹ بنانا اور ڈرا ٹکٹ کی خریداری</a>
												<p>گلف ٹکٹ کھیلنے کے لیے آپ کو اکاؤنٹ بنانا ہوگا اور ڈرا ٹکٹ خریدنا ہوگا۔</p>
												<p>آپ اس بات کو یقینی بنانے کے ذمہ دار ہیں کہ آپ کے اکاؤنٹ کی معلومات درست اور تازہ ترین ہیں۔</p>
												<p>گلف ٹکٹ اکاؤنٹ کی غلط یا پرانی معلومات کے نتیجے میں ہونے والے کسی نقصان یا خسارے کے لیے ذمہ دار نہیں ہے۔
												</p>
												<p>اگر آپ غلط یا گمراہ کن معلومات فراہم کرتے ہیں تو گلف ٹکٹ آپ کے اکاؤنٹ کو معطل یا ختم کرنے کا حق محفوظ رکھتا ہے۔</p>
											</li>
											<li>
												<a >ادائیگی کے طریقے</a>
												<p>گلف ٹکٹ ڈرا ٹکٹ کی خریداریوں کے لیے ادائیگی کے درج ذیل طریقوں کو قبول کرتا ہے:</p>
												<ul>
													<li>
														<p>کریڈٹ کارڈ</p>
													</li>
													<li>
														<p>ڈیبٹ کارڈ</p>
													</li>
													<li>
														<p>نیٹ بینکنگ</p>
													</li>
													<li>
														<p>موبائل والیٹ</p>
													</li>
												</ul>
											</li>
											<li>
												<a >گلف ٹکٹ ڈراز اور جیتنے والے ٹکٹ</a>
												<p>گلف ٹکٹ کی ویب سائٹ پر کیے گیے اعلان کے مطابق گلف ٹکٹ ڈراز مستقل بنیادوں پر ہوتے ہیں۔</p>
												<p>ریفل جیتنے والے ٹکٹوں کا تعین بے ترتیب نمبر جنریٹر کے ذریعے کیا جاتا ہے۔</p>
												<p>آپ جو ڈرا گیم کھیلتے ہیں اس کے لحاظ سے جیتنے کے امکانات مختلف ہوتے ہیں۔</p>
											</li>
											<li>
												<a >نتائج</a>
												<p>ہر ڈرا کے لیے جیتنے والے نمبر ہر ڈرا کے بعد ویب سائٹ پر اور کسٹمر سپورٹ کو کال کرکے دستیاب کرائے جائیں گے۔ جیتنے والے نمبروں کو شائع کرنے میں ہماری طرف سے کسی ناکامی یا جیتنے والے اندراجات کے حاملین کو مطلع کرنے میں ناکامی کے لیے آپ کو معاوضے کا دعویٰ کرنے کا حق نہیں ہوگا؛ جیتنے والے نمبروں کے مقابل اپنے اندراجات کی جانچ کرنا مکمل طور پر آپ کی ذمہ داری ہے۔</p>
												<p>آپ کسی اعلان یا طباعت، پرنٹنگ وغیرہ کی شکل میں موجود اشاعت میں شامل کسی غلطی یا قرعہ اندازی میں انعامات کی رقم کی کسی اشاعت یا اعلان کی وجہ سے معاوضے کا دعوی کرنے کے حقدار نہيں ہوں گے اور نہ ہم ادا کرنے کے پابند ہوں گے (بغیر کسی تحدید کے ان جگہوں کے بشمول جہاں انعامات میں ادا کی جانے والی رقم کو حتمی شکل دینے سے پہلے اعلان یا اشاعت کی جاتی ہے)۔</p>
												<p>ویب سائٹ اور/یا دیگر اعلان یا اشاعت پر شائع کردہ جیتنے والے نمبروں اور سنٹرل کمپیوٹر سسٹم پر موجود باضابطہ جیتنے والے نمبروں کے درمیان فرق کی صورت میں، مؤخر الذکر کو فوقیت دی جائے گی۔</p>
												<p>اگر جیتنے والے اندراجات کی حتمی تصدیق شدہ تعداد عارضی جیتنے والے اندراجات کی ابتدائی شائع کردہ تعداد سے مختلف ہے، تو ایسے جیتنے والوں کو ادا کی جانے والی انعامی رقم مختلف ہو سکتی ہے۔</p>
											</li>
											<li>
												<a >انعام جیتنا</a>
												<a >ریفل ڈرا</a>
												<p>ہر ریفل ڈرا کے لیے کم از کم تین (3) جیتنے والی ریفل آئی ڈیز ہوں گی۔</p>
												<p>جن شرکاء کی ریفل آئی ڈیز جیتنے والی ریفل آئی ڈیزسے مماثلت رکھتی ہیں، ان میں سے ہر ایک 100,000 اماراتی درہم (ایک لاکھ درہم) یا اس طرح کی دوسری رقم جیتے گی جس کا تعین اور اعلان ہماری اپنی صوابدید پر ہو سکتا ہے۔</p>
												<p>کسی بھی ریفل پرائز کا دعویٰ ریفل پرائز جیتنے کی تاریخ کے 60 کیلنڈر دنوں کے اندر کیا جانا چاہیے۔ اگر آپ متحدہ عرب امارات سے باہر رہتے ہیں، تو آپ سے ریفل پرائز کا دعوی کرنے کے لیے متحدہ عرب امارات میں حاضر ہونے کے لیے کہا جا سکتا ہے۔</p>
												<p>ہماری طرف سے ملنے والی اطلاع کے مطابق آپ سے پبلک ریلیشنز، میڈیا کی سرگرمیوں میں شرکت کرنے کا مطالبہ کیا جا سکتا ہے۔</p>
											</li>
											<li>
												<a >گرینڈ ڈرا</a>
												<ul>
													<li>
														<p>تمام انعامات یو اے ای درہم (اے ای ڈی) میں ہیں۔</p>
														<p>ڈرا کا منیجر پیشگی اطلاع کے بغیر ان شرائط و ضوابط میں ترمیم کرنے کا حق محفوظ رکھتا ہے۔</p>
														<p>ڈرا کا مینیجر اپنی صوابدید کے مطابق میچ پرائز کو تبدیل کر سکتا ہے۔ میچ کا انعام میچ کے تمام چار جیتنے والے شرکاء میں برابر تقسیم کیا جائے گا۔</p>
														<p>قابل اطلاق قوانین کے مطابق انعامات پر ٹیکس لگتا ہے۔</p>
													</li>
												</ul>
											</li>
											<li>
												<a >●	فورچیون 5</a>
												<p></p>
												<ul>
													<li>
														<p>میچ ٹو – شرکت کنندہ نے ڈرا کے جیتنے والے نمبروں سے کسی ایک (1) لائن میں دو (2) نمبروں کو صحیح طریقے سے ملایا ہے۔</p>
													</li>
													<li>
														<p>میچ تھری – شرکت کنندہ نے ڈرا کے جیتنے والے نمبروں سے کسی ایک (1) لائن میں تین (3) نمبروں کو صحیح طریقے سے ملایا ہے۔</p>
													</li>
													<li>
														<p>میچ فور – شرکت کنندہ نے ڈرا کے جیتنے والے نمبروں سے کسی ایک (1) لائن میں چار (4) نمبروں کو صحیح طریقے سے ملایا ہے؛ اور</p>
													</li>
													<li>
														<p>میچ پانچ – شرکت کنندہ نے گرینڈ ڈرا جیتنے والے نمبروں سے کسی ایک (1) لائن میں تمام پانچ (5) نمبروں کو صحیح طریقے سے ملایا ہے۔</p>
													</li>
												</ul>
											</li>
											<li>
												<a >سوپر 6</a>
												<ul>
													<li>
														<p>میچ ٹو – شرکت کنندہ نے ڈرا کے جیتنے والے نمبروں سے کسی ایک (1) لائن میں دو (2) نمبروں کو صحیح طریقے سے ملایا ہے۔</p>
													</li>
													<li>
														<p>میچ تھری – شرکت کنندہ نے ڈرا کے جیتنے والے نمبروں سے کسی ایک (1) لائن میں تین (3) نمبروں کو صحیح طریقے سے ملایا ہے۔</p>
													</li>
													<li>
														<p>میچ فور – شرکت کنندہ نے ڈرا کے جیتنے والے نمبروں سے کسی ایک (1) لائن میں چار (4) نمبروں کو صحیح طریقے سے ملایا ہے؛ اور</p>
													</li>
													<li>
														<p>میچ فائیو – شرکت کنندہ نے دوسرے ڈرا کے جیتنے والے نمبروں سے کسی ایک (1) لائن میں تمام پانچ (5) نمبروں کو صحیح طریقے سے ملایا ہے۔</p>
													</li>
													<li>
														<p>میچ سکس – شرکت کنندہ نے گرینڈ ڈرا جیتنے والے نمبروں سے کسی ایک (1) لائن میں تمام پانچ (6) نمبروں کو صحیح طریقے سے ملایا ہے۔</p>
													</li>
												</ul>
												<p>فورچیون  5 کے لیے، پانچ نمبر والے میچز کو فی گرینڈ ڈرا 1,000,000 اماراتی درہم (ایک ملین درہم) کا سب سے بڑا انعام ملے گا۔</p>
												<p>سوپر 6 گیمز کے لیے، چھ نمبر والے میچز کو فی گرانڈ ڈرا 100,000,000 اماراتی درہم  (ایک سو ملین درہم) کا عظیم الشان انعام ملے گا۔</p>
											</li>
											<li>
												<a >جیت کا دعوی کرنا</a>
												<p>آپ کو ڈرا جیتنے کے 30 دنوں کے اندر اپنی جیت کا دعوی کرنا ہوگا۔ جس جیت کا دعوی نہیں کیا جائے گا، اسے گلف ٹکٹ میں ضبط کرلیا جائے گا۔ اپنی جیت کا دعوی کرنے کے لیے، آپ کو اپنے گلف ٹکٹ اکاؤنٹ میں لاگ ان کرنا ہوگا اور دعوی کا فارم جمع کرانا ہوگا۔ گلف ٹکٹ آپ کے دعوے کی تصدیق کرے گا اور 7 کاروباری دنوں کے اندر آپ کی جیت کی رقم آپ کے اکاؤنٹ میں ادا کرے گا۔  100,000اماراتی درہم سے زیادہ جیتی ہوئی رقم بینک ٹرانسفر کے ذریعے ادا کی جائے گی۔  100,000اماراتی درہم سے کم جیتی ہوئی رقم بینک ٹرانسفر، چیک کے ذریعے ادا کی جا سکتی ہے۔</p>
											</li>
											<li>
												<a >ٹیکس</a>
												<p>گلف ٹکٹ سے تمام جیتی ہوئی رقم متحدہ عرب امارات کے ٹیکس قوانین کے تابع آتی ہیں۔ حکومت کے ضوابط کے مطابق آپ کے ملک میں اضافی ٹیکس بھی لاگو ہو سکتا ہے۔</p>
												<p>گلف ٹکٹ آپ کو ادائیگی کرنے سے پہلے آپ کی جیتی ہوئی رقم سے قابل اطلاق ٹیکس کی رقم کاٹ لے گا۔</p>
											</li>
											<li>
												<a >ذمہ دار گیمنگ</a>
												<p>گلف ٹکٹ ذمہ دار گیمنگ کے لیے پرعزم ہے۔ ہم اپنے اراکین کی حوصلہ افزائی کرتے ہیں کہ وہ ذمہ داری سے کھیلیں اور اپنے اخراجات کی حد مقرر کریں۔</p>
												<p>اگر آپ کو حد سے زیادہ خرچ کرنے میں کوئی مسئلہ ہے، تو براہ کرم مدد کے لیے گلف ٹکٹ کسٹمر سپورٹ ٹیم سے رابطہ کریں۔</p>
											</li>
											<li>
												<a >دانشورانہ ملکیت</a>
												<p>گلف ٹکٹ کے لوگو، تجارتی علامات اور کاپی رائٹ سمیت گلف ٹکٹ کی ویب سائٹ پر موجود تمام مواد گلف ٹکٹ کی ملکیت ہیں۔</p>
												<p>آپ کو گلف ٹکٹ کی واضح تحریری اجازت کے بغیر گلف ٹکٹ کی کوئی بھی دانشورانہ ملکیت استعمال کرنے کی اجازت نہیں ہے۔</p>
											</li>
											<li>
												<a >لاگو قانون اور تنازعات کا حل</a>
												<p>ان شرائط و ضوابط پر متحدہ عرب امارات کے قوانین لاگو ہوتے ہیں اور یہ انہیں کے مطابق تشکیل دیئے گیے ہیں۔</p>
												<p>ان شرائط و ضوابط سے پیدا ہونے والے کسی بھی تنازعہ کو متحدہ عرب امارات کی عدالتوں کے ذریعے حل کیا جائے گا۔</p>
											</li>
											<li>
												<a >شرائط و ضوابط میں تبدیلیاں</a>
												<p>گلف ٹکٹ کسی بھی وقت ان شرائط و ضوابط کو تبدیل کرنے کا حق محفوظ رکھتا ہے۔</p>
												<p>اگر ہم کوئی تبدیلی کرتے ہیں، تو ہم اپنی ویب سائٹ پر تازہ ترین شرائط و ضوابط پوسٹ کریں گے۔</p>
											</li>
											<li>
												<a >ہم سے رابطہ کریں</a>
												<p>اگر آپ کے پاس ان شرائط و ضوابط کے بارے میں کوئی سوال ہے تو، براہ کرم ہم سے [helpdesk@gulfticket.com] پر رابطہ کریں</p>
												<p>گلف ٹکٹ کھیلنے کے لیے آپ کا شکریہ!</p>
											</li>
											<li>
												<a >اضافی شرائط و ضوابط</a>
												<p>گلف ٹکٹ ایسی کسی بھی تکنیکی دشواری کے لیے ذمہ دار نہیں ہے جو آپ کو ڈرا کھیلنے یا اپنی جیت کا دعوی کرنے سے روک سکتی ہے۔</p>
												<p>گلف ٹکٹ کسی بھی وقت کسی بھی گلف ٹکٹ ڈرا کو منسوخ یا معطل کرنے کا حق محفوظ رکھتا ہے۔</p>
												<p>اگر کوئی کھلاڑی ان شرائط و ضوابط کی خلاف ورزی کرتا ہے یا کسی دھوکہ دہی یا غیر قانونی سرگرمی میں ملوث ہوتا ہے، تو گلف ٹکٹ اسے ڈرا کھیلنے یا اپنی جیت کا دعوی کرنے سے نااہل قرار دینے کا حق محفوظ رکھتا ہے۔</p>
												<p>گلف ٹکٹ اپنے کھلاڑیوں کی رازداری کی حفاظت کرنے کے لیے پرعزم ہے۔ آپ کی ذاتی معلومات کو اکٹھا، استعمال اور اس کا اشتراک کرنے کے بارے میں مزید معلومات کے لیے براہ کرم ہماری رازداری کی پالیسی کا جائزہ لیں۔</p>
											</li>
										</ul>
									</div>
								</div> 
					}*/}
				</div >
			</>

		);
	}
}
function mapStateToProps(state) {
	const { user } = state.loginReducer;
	return { user };
}
const mapActionToProps = {
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(TermsCondition))